function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path979",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.824007,224.00349 c -1.243541,-1.5046 -2.924527,-2.58728 -4.793898,-3.10339 1.406173,-0.82621 3.044121,-1.30034 4.793192,-1.30034 1.749425,0 3.387725,0.47413 4.79425,1.30069 -1.868662,0.51647 -3.550354,1.59879 -4.793544,3.10304"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path981",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.202824,225.13767 c -1.590323,-1.13101 -3.494087,-1.74167 -5.43313,-1.75648 1.144446,-1.16206 2.604064,-2.04365 4.29327,-2.49626 0.821585,-0.22013 1.647153,-0.32526 2.458895,-0.32526 0.857605,0 1.700742,0.11747 2.50825,0.34043 -1.671812,0.98213 -3.015543,2.46274 -3.827285,4.23757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path983",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.113842,229.13428 c -0.592312,-0.16333 -1.20932,-0.25364 -1.837266,-0.26246 -0.123119,-0.29034 -0.245534,-0.54257 -0.366184,-0.75177 -0.702378,-1.21673 -1.633008,-2.21827 -2.707568,-2.98238 0.811742,-1.77483 2.155473,-3.25544 3.827285,-4.23757 1.869371,0.51611 3.550357,1.59879 4.793898,3.10339 -0.839965,1.01599 -1.480608,2.22461 -1.844323,3.58104 -0.06244,0.23319 -0.115358,0.50835 -0.159102,0.82056 -0.603956,0.1711 -1.176866,0.41804 -1.70674,0.72919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path985",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.169616,228.46507 c -1.065777,-0.39688 -2.189163,-0.59549 -3.312125,-0.59549 -0.803945,0 -1.607467,0.1016 -2.390493,0.30515 0.804651,-1.41887 1.986457,-2.6483 3.500932,-3.52249 1.492002,-0.86148 3.121801,-1.27141 4.728986,-1.27141 0.02441,0 0.04837,3.5e-4 0.07278,3.5e-4 -1.360417,1.38147 -2.275135,3.15947 -2.600078,5.08388"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path987",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 27.105275,231.27635 c -0.194169,-0.24871 -0.377719,-0.46073 -0.548464,-0.63147 -0.99314,-0.99342 -2.151662,-1.71979 -3.387195,-2.17981 0.324943,-1.92441 1.239661,-3.70241 2.600078,-5.08389 1.939043,0.0148 3.842807,0.62548 5.43313,1.75649 -0.548394,1.19873 -0.853898,2.53188 -0.853898,3.93664 0,0.2413 0.02024,0.52106 0.0587,0.83432 -0.539361,0.32174 -1.028311,0.70803 -1.459476,1.14582 -0.01876,0 -0.03764,-3.4e-4 -0.05623,-3.4e-4 -0.596301,0 -1.196129,0.073 -1.786644,0.22225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path989",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 30.407627,229.90863 c -0.03845,-0.31326 -0.0587,-0.59302 -0.0587,-0.83432 0,-1.40476 0.305504,-2.73791 0.853898,-3.93664 1.07456,0.76411 2.00519,1.76565 2.707568,2.98238 0.12065,0.2092 0.243065,0.46143 0.366184,0.75177 -0.03457,-7.2e-4 -0.06879,-7.2e-4 -0.103362,-7.2e-4 -0.628298,0 -1.26718,0.0815 -1.903238,0.25189 -0.670277,0.17956 -1.294342,0.44661 -1.862349,0.78563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path991",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 10.687738,234.95335 c 0.410104,-1.57832 1.233347,-3.07163 2.470009,-4.30847 1.236804,-1.23684 2.730712,-2.06022 4.309251,-2.47015 -0.956486,1.68628 -1.37996,3.64067 -1.195564,5.58341 -0.297674,-0.0282 -0.595735,-0.0423 -0.892845,-0.0423 -1.642604,0 -3.262489,0.42757 -4.690851,1.23754"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path993",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 20.80036,235.455 c -0.251919,-0.18979 -0.483976,-0.34713 -0.693032,-0.46778 -1.216519,-0.70238 -2.523454,-1.10455 -3.835894,-1.22908 -0.184396,-1.94274 0.239078,-3.89713 1.195564,-5.58341 0.783026,-0.20355 1.586548,-0.30515 2.390493,-0.30515 1.122962,0 2.246348,0.19861 3.312125,0.59549 -0.219393,1.29998 -0.169651,2.66664 0.194027,4.02343 0.06241,0.23318 0.154341,0.49812 0.272557,0.79057 -0.437798,0.4505 -0.810014,0.95003 -1.113297,1.48484 -0.594924,0.15452 -1.174114,0.38488 -1.722543,0.69109"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path995",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.6362,233.27907 c -0.118216,-0.29245 -0.21015,-0.55739 -0.272557,-0.79057 -0.363678,-1.35679 -0.41342,-2.72345 -0.194027,-4.02343 1.235533,0.46002 2.394055,1.18639 3.387195,2.17981 0.170745,0.17074 0.354295,0.38276 0.548464,0.63147 -0.641456,0.16193 -1.271799,0.41452 -1.873038,0.76165 -0.601204,0.34713 -1.134922,0.76658 -1.596037,1.24107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path997",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 5.8941225,243.25633 c -0.01256,-1.63089 0.39617,-3.28683 1.270671,-4.8013 0.8745,-1.51483 2.104248,-2.69699 3.5229445,-3.50168 -0.487257,1.87678 -0.390525,3.87421 0.290372,5.70301 -1.9247215,0.32456 -3.7023685,1.23931 -5.0839875,2.59997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path999",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 15.791868,241.12308 c -0.292558,-0.11818 -0.557424,-0.2099 -0.790575,-0.27234 -0.821584,-0.22013 -1.646907,-0.32526 -2.45872,-0.32526 -0.528602,0 -1.051842,0.0444 -1.564463,0.13088 -0.680897,-1.8288 -0.777629,-3.82623 -0.290372,-5.70301 1.428362,-0.80997 3.048247,-1.23754 4.690851,-1.23754 0.29711,0 0.595171,0.0141 0.892845,0.0423 0.124425,1.31269 0.526274,2.61973 1.228514,3.83611 0.12072,0.2092 0.278095,0.44132 0.467995,0.69321 -0.306353,0.54821 -0.536505,1.12712 -0.691092,1.72226 -0.534705,0.30339 -1.034627,0.67557 -1.484983,1.11336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1001",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 17.967943,238.28746 c -0.1899,-0.25189 -0.347275,-0.48401 -0.467995,-0.69321 -0.70224,-1.21638 -1.104089,-2.52342 -1.228514,-3.83611 1.31244,0.12453 2.619375,0.5267 3.835894,1.22908 0.209056,0.12065 0.441113,0.27799 0.693032,0.46778 -0.577815,0.32244 -1.121198,0.72955 -1.612335,1.22062 -0.490855,0.49071 -0.897644,1.03434 -1.220082,1.61184"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1003",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 3.4128249,252.5164 c -0.4342341,-1.57198 -0.4679949,-3.27696 -0.015311,-4.96641 0.4526844,-1.68945 1.3344877,-3.14925 2.4966086,-4.29366 0.01485,1.93887 0.625334,3.84281 1.756304,5.43313 -1.774649,0.81174 -3.2553629,2.15548 -4.2376021,3.82694"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1005",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 7.6504265,248.68946 c -1.13097,-1.59032 -1.741452,-3.49426 -1.756304,-5.43313 1.381619,-1.36066 3.159266,-2.27541 5.0839875,-2.59997 0.459986,1.23578 1.186497,2.3943 2.179637,3.38772 0.170745,0.17075 0.382694,0.35384 0.631261,0.54822 -0.297074,1.17546 -0.291042,2.39007 -0.01058,3.53554 -0.895173,-0.18733 -1.641651,-0.29175 -2.191491,-0.29175 -4.23e-4,0 -4.23e-4,0 -7.14e-4,0 -1.404373,0 -2.7370625,0.30516 -3.9358015,0.85337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1007",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 13.789008,244.5923 c -0.248567,-0.19438 -0.460516,-0.37747 -0.631261,-0.54822 -0.99314,-0.99342 -1.719651,-2.15194 -2.179637,-3.38772 0.512621,-0.0864 1.035861,-0.13088 1.564463,-0.13088 0.811813,0 1.637136,0.10513 2.45872,0.32526 0.233151,0.0624 0.498017,0.15416 0.790575,0.27234 -0.47445,0.46109 -0.89408,0.99484 -1.241213,1.59632 -0.347239,0.60149 -0.599581,1.2312 -0.761647,1.8729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 3.4125427,262.10348 c -0.826276,-1.40617 -1.3000566,-3.04447 -1.3000566,-4.79319 0,-1.74907 0.4740628,-3.38772 1.3003388,-4.79389 0.5161845,1.86901 1.5985066,3.55035 3.1026456,4.79389 -1.50428,1.24319 -2.5867081,2.92418 -3.1029278,4.79319"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1011",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 6.5154705,257.31029 c -1.504139,-1.24354 -2.5864611,-2.92488 -3.1026456,-4.79389 0.9822392,-1.67146 2.4629536,-3.0152 4.2376016,-3.82694 0.764117,1.07456 1.765653,2.00554 2.9822075,2.70792 0.47625,0.27517 1.174644,0.55739 2.043642,0.84279 -0.815799,0.85196 -1.42808,1.90041 -1.758527,3.0674 -0.312561,0.0438 -0.587728,0.0967 -0.820914,0.15911 -1.3568185,0.36371 -2.5652235,1.00365 -3.5813645,1.84361"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1013",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 12.676276,252.24017 c -0.868998,-0.2854 -1.567392,-0.56762 -2.043642,-0.84279 -1.2165545,-0.70238 -2.2180905,-1.63336 -2.9822075,-2.70792 1.198739,-0.54821 2.5314285,-0.85337 3.9358015,-0.85337 2.91e-4,0 2.91e-4,0 7.14e-4,0 0.54984,0 1.296318,0.10442 2.191491,0.29175 0.219358,0.89606 0.606743,1.75013 1.148186,2.51142 -0.849841,0.38841 -1.612194,0.93451 -2.250334,1.60091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1015",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 5.8936995,271.36386 c -1.1622618,-1.14448 -2.043924,-2.60416 -2.4964673,-4.29326 -0.4526844,-1.68946 -0.4189236,-3.39514 0.015311,-4.96712 0.9823803,1.67147 2.4629533,3.01555 4.2377433,3.82729 -1.1315,1.59032 -1.741699,3.49391 -1.756587,5.43309"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1017",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 7.6502855,265.93077 c -1.774789,-0.81174 -3.2553625,-2.15582 -4.2377428,-3.82729 0.5162197,-1.86901 1.5986478,-3.55 3.1029278,-4.79319 1.016035,0.83997 2.224546,1.48026 3.5813645,1.84362 0.233186,0.0628 0.508494,0.11536 0.820914,0.15945 0.171133,0.60396 0.417971,1.17652 0.729262,1.70604 -0.163724,0.59266 -0.253859,1.20967 -0.262784,1.83797 -0.290512,0.12312 -0.542537,0.24518 -0.751593,0.36618 -1.2164135,0.70203 -2.2182315,1.63336 -2.9823485,2.70722"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1019",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 10.917749,259.31336 c -0.31242,-0.0441 -0.587728,-0.0967 -0.820914,-0.15945 -1.3568185,-0.36336 -2.5653295,-1.00365 -3.5813645,-1.84362 1.016141,-0.83996 2.224546,-1.4799 3.5813645,-1.84361 0.233186,-0.0624 0.508353,-0.11536 0.820914,-0.15911 -0.180375,0.63642 -0.277001,1.30846 -0.277001,2.00272 0,0.69427 0.09663,1.36631 0.277001,2.00307"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1021",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 10.687209,279.66652 c -1.4186965,-0.80475 -2.6484795,-1.98656 -3.5228395,-3.50103 -0.874501,-1.51448 -1.283229,-3.17073 -1.27067,-4.80163 1.38176,1.36067 3.159266,2.27542 5.0839865,2.59994 -0.681178,1.8288 -0.77791,3.82598 -0.290477,5.70272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1023",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 10.977686,273.9638 c -1.9247205,-0.32452 -3.7022265,-1.23927 -5.0839865,-2.59994 0.01489,-1.93918 0.625087,-3.84277 1.756586,-5.43309 1.19888,0.54857 2.5318515,0.85408 3.9366475,0.85408 0.241406,0 0.520877,-0.0201 0.833967,-0.0586 0.321769,0.53904 0.708167,1.02834 1.145999,1.45944 -0.0047,0.61489 0.06777,1.23359 0.221862,1.84294 -0.248603,0.19431 -0.460552,0.37744 -0.631296,0.54818 -0.992999,0.99304 -1.719792,2.15195 -2.179779,3.38695"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1025",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 11.586933,266.78485 c -1.404796,0 -2.7377675,-0.30551 -3.9366475,-0.85408 0.764117,-1.07386 1.765935,-2.00519 2.9823485,-2.70722 0.209056,-0.121 0.461081,-0.24306 0.751593,-0.36618 -0.0095,0.66146 0.07109,1.33527 0.25079,2.00589 0.179846,0.67064 0.446899,1.2947 0.785883,1.86303 -0.31309,0.0384 -0.592561,0.0586 -0.833967,0.0586 m 28.236368,-9.4742 v 0 0 0 0 m 0,0 v 0 0 0 0 m 0,0 v 0 0 0 m 0,0 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1027",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 17.465905,286.44578 c -1.57854,-0.40982 -3.071918,-1.23334 -4.30844,-2.46972 -1.23691,-1.23719 -2.060293,-2.73057 -2.470256,-4.30954 1.428468,0.8103 3.048635,1.2379 4.691662,1.2379 0.296687,0 0.594607,-0.0142 0.891858,-0.0423 -0.184644,1.94303 0.23883,3.89668 1.195176,5.58366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1029",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 15.378871,280.90442 c -1.643027,0 -3.263194,-0.4276 -4.691662,-1.2379 -0.487433,-1.87674 -0.390701,-3.87392 0.290477,-5.70272 0.513186,0.0868 1.036708,0.13159 1.566016,0.13159 0.811248,0 1.636536,-0.10513 2.457591,-0.32519 0.233151,-0.0624 0.497876,-0.1542 0.790293,-0.27231 0.86995,0.84487 1.924156,1.44667 3.056784,1.77655 -0.609811,0.6816 -1.073644,1.27593 -1.348705,1.75218 -0.702239,1.21613 -1.104229,2.52349 -1.228936,3.8355 -0.297251,0.0281 -0.595171,0.0423 -0.891858,0.0423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1031",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 12.543702,274.09539 c -0.529308,0 -1.05283,-0.0448 -1.566016,-0.13159 0.459987,-1.235 1.18678,-2.39391 2.179779,-3.38695 0.170744,-0.17074 0.382693,-0.35387 0.631296,-0.54818 0.162031,0.64135 0.414373,1.27166 0.761506,1.8729 0.347239,0.60138 0.766868,1.13481 1.241319,1.59632 -0.292417,0.11811 -0.557142,0.20987 -0.790293,0.27231 -0.821055,0.22006 -1.646343,0.32519 -2.457591,0.32519 m 27.279599,-16.78474 v 0 0 0 0 m 0,0 v 0 0 0 0 m 0,0 v 0 0 0 0 m 0,0 v 0 0 0 m 0,0 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1033",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 25.695399,291.23972 c -1.607468,0 -3.235749,-0.40916 -4.727893,-1.27071 -1.515004,-0.8745 -2.696951,-2.10425 -3.501601,-3.52323 0.78299,0.20328 1.586935,0.30484 2.390775,0.30484 1.122962,0 2.246171,-0.1983 3.312089,-0.59517 0.324556,1.92444 1.239273,3.70251 2.59969,5.08399 -0.02441,2.6e-4 -0.04865,2.6e-4 -0.07306,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1035",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 19.85668,286.75062 c -0.80384,0 -1.607785,-0.10156 -2.390775,-0.30484 -0.956346,-1.68698 -1.37982,-3.64063 -1.195176,-5.58366 1.312439,-0.12417 2.619798,-0.52599 3.836176,-1.22837 0.47625,-0.27478 1.070045,-0.73836 1.751647,-1.34842 0.330024,1.13249 0.931828,2.18694 1.777259,3.0565 -0.118251,0.29242 -0.210149,0.55739 -0.272591,0.79058 -0.363679,1.35639 -0.413561,2.72341 -0.194451,4.02304 -1.065918,0.39687 -2.189127,0.59517 -3.312089,0.59517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1037",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 16.270729,280.86212 c 0.124707,-1.31201 0.526697,-2.61937 1.228936,-3.8355 0.275061,-0.47625 0.738894,-1.07058 1.348705,-1.75218 0.666397,0.19403 1.359959,0.29422 2.058635,0.29422 0.229729,0 0.460269,-0.011 0.690245,-0.0328 -0.0883,0.93021 0.0033,1.86369 0.261302,2.74948 -0.681602,0.61006 -1.275397,1.07364 -1.751647,1.34842 -1.216378,0.70238 -2.523737,1.1042 -3.836176,1.22837 m 23.552572,-23.55147 v 0 0 0 0 m 0,0 v 0 0 0 0 m 0,0 v 0 0 0 0 m 0,0 v 0 0 0 m 0,0 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1039",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 32.520097,294.06123 c -0.81139,0 -1.636361,-0.10512 -2.457556,-0.32494 -1.689594,-0.45254 -3.149495,-1.33449 -4.294082,-2.49685 1.93862,-0.0153 3.843195,-0.62548 5.433307,-1.75659 0.811741,1.77493 2.155473,3.25547 3.826933,4.23802 -0.80786,0.22324 -1.650648,0.34036 -2.508602,0.34036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1041",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 25.768459,291.23944 c -1.360417,-1.38148 -2.275134,-3.15955 -2.59969,-5.08399 1.23571,-0.45999 2.394338,-1.18636 3.387795,-2.17939 0.17071,-0.17071 0.354013,-0.3828 0.548182,-0.63154 0.590197,0.14925 1.189637,0.222 1.785654,0.222 0.01886,0 0.03789,0 0.05676,-5.3e-4 0.431482,0.43822 0.920395,0.82476 1.460039,1.14653 -0.03845,0.31295 -0.0587,0.59298 -0.0587,0.83428 -1.43e-4,1.40448 0.305223,2.7372 0.853263,3.93594 -1.590112,1.13112 -3.494687,1.74128 -5.433307,1.75659"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1043",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.168769,286.15545 c -0.21911,-1.29963 -0.169228,-2.66665 0.194451,-4.02304 0.06244,-0.23319 0.15434,-0.49816 0.272591,-0.79058 0.461081,0.47445 0.994799,0.89433 1.596038,1.24146 0.60138,0.34713 1.231406,0.5993 1.872897,0.76123 -0.194169,0.24874 -0.377472,0.46083 -0.548182,0.63154 -0.993457,0.99303 -2.152085,1.7194 -3.387795,2.17939 m 16.654532,-28.8448 v 0 0 0 0 m 0,0 v 0 0 0 0 m 0,0 v 0 0 0 0 m 0,0 v 0 0 0 0 m 0,0 v 0 0 0 m 0,0 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1045",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822949,295.02118 c -1.749425,0 -3.387725,-0.47375 -4.79425,-1.30031 1.869017,-0.51621 3.550356,-1.59854 4.793543,-3.10278 1.243542,1.50467 2.924175,2.58657 4.793547,3.10307 -1.406173,0.82627 -3.044122,1.30002 -4.79284,1.30002"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1047",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.028699,293.72087 c -1.67146,-0.98255 -3.015192,-2.46309 -3.826933,-4.23802 1.07456,-0.76412 2.005893,-1.76555 2.708275,-2.98193 0.12065,-0.20919 0.243064,-0.4615 0.366183,-0.75187 0.627943,-0.009 1.244248,-0.0991 1.83656,-0.26279 0.530225,0.31186 1.102783,0.55852 1.707446,0.72994 0.04374,0.31213 0.09666,0.58734 0.159102,0.82091 0.36336,1.3564 1.0033,2.56508 1.84291,3.58098 -1.243187,1.50424 -2.924526,2.58657 -4.793543,3.10278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1049",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.201766,289.48285 c -0.54804,-1.19874 -0.853406,-2.53146 -0.853263,-3.93594 0,-0.2413 0.02024,-0.52134 0.0587,-0.83429 0.568079,0.33874 1.192144,0.60608 1.862773,0.78564 0.635706,0.17046 1.273881,0.2515 1.901825,0.2515 0.03493,0 0.0695,-2.7e-4 0.104423,-8e-4 -0.123119,0.29037 -0.245533,0.54268 -0.366183,0.75188 -0.702382,1.21638 -1.633715,2.2178 -2.708275,2.98192 m 8.621535,-32.1722 v 0 0 0 0 m 0,0 v 0 0 0 0 m 0,0 v 0 0 0 0 m 0,0 v 0 0 0 0 m 0,0 v 0 0 0 0 m 0,0 v 0 0 0 m 0,0 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1051",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.124391,294.06166 c -0.857957,0 -1.700742,-0.11755 -2.508602,-0.3405 1.67146,-0.98242 3.015543,-2.46313 3.827285,-4.23789 1.590323,1.13164 3.49391,1.7417 5.433131,1.75687 -1.144413,1.16194 -2.603854,2.04361 -4.292954,2.49615 -0.821267,0.22024 -1.647119,0.32537 -2.45886,0.32537"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1053",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.615789,293.72116 c -1.869372,-0.5165 -3.550005,-1.5984 -4.793547,-3.10307 0.840317,-1.0159 1.480609,-2.22501 1.844324,-3.5814 0.06244,-0.23344 0.115358,-0.50836 0.159101,-0.82088 0.604309,-0.17103 1.176515,-0.41769 1.706034,-0.72912 0.592666,0.16369 1.209675,0.25396 1.837973,0.26278 0.123118,0.29034 0.245533,0.54254 0.366183,0.75174 0.702027,1.21637 1.63336,2.21795 2.707217,2.98206 -0.811742,1.77476 -2.155825,3.25547 -3.827285,4.23789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1055",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822242,290.61809 c -0.83961,-1.0159 -1.47955,-2.22458 -1.84291,-3.58098 -0.06244,-0.23357 -0.115358,-0.50878 -0.159102,-0.82091 0.636411,0.18027 1.308452,0.27686 2.002719,0.27686 0.694267,-2.7e-4 1.366308,-0.0966 2.002718,-0.27725 -0.04374,0.31252 -0.09666,0.58744 -0.159101,0.82088 -0.363715,1.35639 -1.004007,2.5655 -1.844324,3.5814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1057",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.949582,291.24014 c -0.02468,0 -0.04903,0 -0.07338,0 1.360311,-1.3819 2.275062,-3.15987 2.599971,-5.08427 1.066093,0.39727 2.18934,0.59542 3.312583,0.59542 0.803627,0 1.607608,-0.10153 2.390069,-0.3048 -0.804334,1.41856 -1.986137,2.64802 -3.500612,3.52252 -1.491899,0.86155 -3.121732,1.27113 -4.728634,1.27113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1059",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.876205,291.24014 c -1.939221,-0.0152 -3.842808,-0.62523 -5.433131,-1.75687 0.548568,-1.19877 0.854427,-2.53188 0.854427,-3.93665 0,-0.2413 -0.02011,-0.52105 -0.05856,-0.83439 1.041048,-0.62124 1.895475,-1.48417 2.507191,-2.49233 0.500592,0.76549 0.954617,1.36771 1.343377,1.75644 0.993071,0.99317 2.151592,1.71951 3.386667,2.17953 -0.324909,1.9244 -1.23966,3.70237 -2.599971,5.08427"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1061",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 48.443074,289.48327 c -1.073857,-0.76411 -2.00519,-1.76569 -2.707217,-2.98206 -0.12065,-0.2092 -0.243065,-0.4614 -0.366183,-0.75174 0.03457,2.7e-4 0.06879,8e-4 0.103365,8e-4 0.628295,0 1.267177,-0.0815 1.902883,-0.25192 0.670629,-0.17957 1.294694,-0.44662 1.863019,-0.78603 0.03845,0.31334 0.05856,0.59309 0.05856,0.83439 0,1.40476 -0.305859,2.73788 -0.854427,3.93665"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1063",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 62.178828,286.44649 c 0.956733,-1.68659 1.380066,-3.64063 1.195564,-5.58369 0.298099,0.0285 0.595842,0.0423 0.893234,0.0423 1.642533,0 3.262135,-0.42761 4.690533,-1.23748 -0.409927,1.57854 -1.23331,3.07192 -2.469798,4.30869 -1.236837,1.23695 -2.7305,2.06033 -4.309533,2.47015"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1065",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 59.788759,286.75129 c -1.123243,0 -2.24649,-0.19815 -3.312583,-0.59542 0.219427,-1.30005 0.169685,-2.66665 -0.193675,-4.02346 -0.142169,-0.53125 -0.436385,-1.22453 -0.849135,-2.04075 1.179335,-0.0258 2.353378,-0.33419 3.412418,-0.92576 0.252235,0.19057 0.48401,0.34752 0.693208,0.4681 1.216377,0.70241 2.523419,1.10423 3.8354,1.2288 0.184502,1.94306 -0.238831,3.8971 -1.195564,5.58369 -0.782461,0.20327 -1.586442,0.3048 -2.390069,0.3048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1067",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.476176,286.15587 c -1.235075,-0.46002 -2.393596,-1.18636 -3.386667,-2.17953 -0.38876,-0.38873 -0.842785,-0.99095 -1.343377,-1.75644 0.478367,-0.78836 0.808567,-1.66618 0.96379,-2.58767 0.825145,0.30731 1.694037,0.46109 2.563281,0.46109 0.05327,0 0.106891,-8e-4 0.160163,-0.002 0.41275,0.81622 0.706966,1.5095 0.849135,2.04075 0.36336,1.35682 0.413102,2.72341 0.193675,4.02346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1069",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 68.958159,279.66765 c 0.48754,-1.87692 0.390525,-3.87395 -0.290335,-5.70275 1.924402,-0.32453 3.702402,-1.23928 5.083879,-2.59966 0.0127,1.63089 -0.395817,3.28648 -1.270352,4.80095 -0.874535,1.51487 -2.104673,2.69667 -3.523192,3.50146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1071",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 64.267626,280.90513 c -0.297392,0 -0.595135,-0.0138 -0.893234,-0.0423 -0.124531,-1.3123 -0.526343,-2.61938 -1.228373,-3.83576 -0.12065,-0.20919 -0.277987,-0.44139 -0.467783,-0.69328 0.306213,-0.54818 0.536575,-1.12737 0.691092,-1.72254 0.534458,-0.30304 1.034698,-0.67553 1.484841,-1.11333 0.293159,0.1185 0.55739,0.21015 0.79093,0.2727 0.821618,0.22009 1.646767,0.32522 2.458508,0.32522 0.52846,0 1.051629,-0.0445 1.564217,-0.13091 0.68086,1.8288 0.777875,3.82583 0.290335,5.70275 -1.428398,0.80987 -3.048,1.23748 -4.690533,1.23748"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1073",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 63.374392,280.8628 c -1.311981,-0.12457 -2.619023,-0.52639 -3.8354,-1.2288 -0.209198,-0.12058 -0.440973,-0.27753 -0.693208,-0.4681 0.577498,-0.32248 1.121127,-0.72912 1.612194,-1.22026 0.490714,-0.49072 0.897821,-1.03434 1.220258,-1.61188 0.189796,0.25189 0.347133,0.48409 0.467783,0.69328 0.70203,1.21638 1.103842,2.52346 1.228373,3.83576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1075",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 73.751703,271.36524 c -0.01482,-1.93876 -0.625475,-3.84309 -1.756127,-5.43341 1.774473,-0.81174 3.255081,-2.15547 4.237566,-3.82693 0.434269,1.57197 0.468136,3.27695 0.01587,4.9664 -0.452966,1.68945 -1.33491,3.1496 -2.497314,4.29394"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1077",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 68.667824,273.9649 c -0.460023,-1.23582 -1.186392,-2.39434 -2.179463,-3.38776 -0.170744,-0.17075 -0.382762,-0.35374 -0.63147,-0.54819 0.15381,-0.60854 0.226483,-1.22763 0.221543,-1.84217 0.438502,-0.43144 0.824794,-0.92039 1.146882,-1.46014 0.312912,0.0385 0.592666,0.0586 0.834318,0.0586 2.65e-4,0 2.65e-4,0 7.94e-4,0 1.403702,0 2.736495,-0.30551 3.935235,-0.85337 1.130652,1.59032 1.74131,3.49465 1.756127,5.43341 -1.381477,1.36038 -3.159477,2.27513 -5.083879,2.59966"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1079",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 67.103607,274.09581 c -0.811741,0 -1.63689,-0.10513 -2.458508,-0.32522 -0.23354,-0.0625 -0.497771,-0.1542 -0.79093,-0.2727 0.474488,-0.46108 0.89394,-0.99452 1.241073,-1.59604 0.347486,-0.60152 0.599724,-1.23116 0.761649,-1.8729 0.248708,0.19445 0.460726,0.37744 0.63147,0.54819 0.993071,0.99342 1.71944,2.15194 2.179463,3.38776 -0.512588,0.0864 -1.035757,0.13091 -1.564217,0.13091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1081",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 76.233142,262.1049 c -0.516114,-1.86902 -1.598435,-3.55001 -3.102681,-4.79355 1.504246,-1.24319 2.586567,-2.92453 3.103033,-4.79354 0.826207,1.40617 1.30034,3.04447 1.30034,4.79319 0,1.74907 -0.474133,3.38737 -1.300692,4.7939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1083",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 71.995576,265.93183 c -0.764117,-1.07456 -1.765652,-2.00554 -2.982032,-2.70792 -0.209195,-0.12101 -0.461433,-0.24307 -0.751768,-0.36654 -0.0092,-0.62759 -0.09913,-1.24425 -0.262819,-1.83656 0.311502,-0.52987 0.558446,-1.10243 0.729544,-1.70709 0.31256,-0.0437 0.587727,-0.0967 0.820915,-0.15911 1.356783,-0.36371 2.565045,-1.00365 3.581045,-1.84326 1.504246,1.24354 2.586567,2.92453 3.102681,4.79355 -0.982485,1.67146 -2.463093,3.01519 -4.237566,3.82693"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1085",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 68.060341,266.7852 c -2.65e-4,0 -2.65e-4,0 -7.94e-4,0 -0.241652,0 -0.521407,-0.0201 -0.834319,-0.0586 0.338667,-0.56798 0.606071,-1.19204 0.785635,-1.86267 0.179565,-0.67063 0.26035,-1.34479 0.250825,-2.0066 0.290336,0.12347 0.542574,0.24553 0.751769,0.36654 1.21638,0.70238 2.217915,1.63336 2.982031,2.70792 -1.198739,0.54786 -2.531533,0.85337 -3.935235,0.85337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1087",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 76.233494,252.51781 c -0.982485,-1.67146 -2.463093,-3.0152 -4.237918,-3.82729 1.131358,-1.58997 1.741665,-3.49426 1.756833,-5.43313 1.16205,1.14406 2.043994,2.60421 2.496608,4.29331 0.452615,1.6898 0.418749,3.39478 -0.01553,4.96711"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1089",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 73.130461,257.31135 c -1.016,-0.84031 -2.224617,-1.48061 -3.5814,-1.84432 -0.233185,-0.0624 -0.508352,-0.11536 -0.82056,-0.1591 -0.330907,-1.16664 -0.943327,-2.21509 -1.75895,-3.06705 0.868891,-0.2854 1.568098,-0.56798 2.044348,-0.84314 1.216377,-0.70203 2.217912,-1.63301 2.981677,-2.70722 1.774825,0.81209 3.255433,2.15583 4.237918,3.82729 -0.516466,1.86901 -1.598787,3.55035 -3.103033,4.79354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1091",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 68.728501,259.31372 c 0.180268,-0.63641 0.276931,-1.30846 0.276931,-2.00272 0,-0.69462 -0.09666,-1.36631 -0.276931,-2.00307 0.312208,0.0437 0.587375,0.0967 0.82056,0.1591 1.356783,0.36371 2.5654,1.004 3.5814,1.84432 -1.016,0.83961 -2.224262,1.47955 -3.581045,1.84326 -0.233188,0.0625 -0.508355,0.11536 -0.820915,0.15911"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1093",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 73.752409,243.25739 c -1.381831,-1.36066 -3.159125,-2.27506 -5.083881,-2.59997 0.680863,-1.8288 0.777875,-3.82623 0.290338,-5.70265 1.41887,0.80433 2.648301,1.98649 3.522837,3.50096 0.874538,1.51483 1.283406,3.17042 1.270706,4.80166"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1095",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 71.995576,248.69052 c -1.19874,-0.54822 -2.531885,-0.85407 -3.936294,-0.85443 -0.549981,0 -1.295754,0.10478 -2.191104,0.2921 0.280458,-1.14582 0.286456,-2.35973 -0.01093,-3.53554 0.249061,-0.19438 0.460727,-0.37747 0.631825,-0.54857 0.993069,-0.99271 1.71944,-2.15159 2.179461,-3.38666 1.924756,0.32491 3.70205,1.23931 5.083881,2.59997 -0.01516,1.93887 -0.625475,3.84316 -1.756833,5.43313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1097",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 66.969551,252.24088 c -0.638175,-0.66605 -1.400175,-1.21215 -2.249665,-1.60091 0.541515,-0.76129 0.928865,-1.61572 1.148292,-2.51178 0.89535,-0.18732 1.641123,-0.2921 2.191104,-0.2921 1.404409,2.7e-4 2.737554,0.30621 3.936294,0.85443 -0.763765,1.07421 -1.7653,2.00519 -2.981677,2.70722 -0.47625,0.27516 -1.175457,0.55774 -2.044348,0.84314"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1099",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 68.958866,234.95477 c -1.428399,-0.81034 -3.048355,-1.2379 -4.691592,-1.2379 -0.296688,0 -0.594432,0.0141 -0.891823,0.0423 0.184502,-1.94275 -0.238832,-3.89678 -1.19521,-5.58341 1.578326,0.40993 3.071987,1.23296 4.308826,2.46979 1.236486,1.23684 2.059869,2.73015 2.469799,4.30919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1101",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 63.854524,241.12379 c -0.450498,-0.4378 -0.950032,-0.80998 -1.484842,-1.11337 -0.154516,-0.59478 -0.384881,-1.17404 -0.691091,-1.72226 0.190145,-0.25223 0.347133,-0.48401 0.468135,-0.69356 0.702027,-1.21602 1.104193,-2.52342 1.228725,-3.8354 0.297391,-0.0282 0.595135,-0.0423 0.891823,-0.0423 1.643237,0 3.263193,0.42756 4.691592,1.2379 0.487537,1.87642 0.390525,3.87385 -0.290338,5.70265 -0.513292,-0.0868 -1.036812,-0.13124 -1.565979,-0.13124 -0.81139,0 -1.636538,0.10513 -2.45745,0.32491 -0.233188,0.0624 -0.498123,0.15417 -0.790575,0.2727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1103",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 65.857242,244.59265 c -0.161925,-0.64135 -0.414514,-1.27141 -0.761648,-1.87254 -0.347133,-0.60149 -0.766585,-1.13524 -1.24107,-1.59632 0.292452,-0.11853 0.557387,-0.21026 0.790575,-0.2727 0.820912,-0.21978 1.64606,-0.32491 2.45745,-0.32491 0.529167,0 1.052687,0.0444 1.565979,0.13124 -0.460021,1.23507 -1.186392,2.39395 -2.179461,3.38666 -0.171098,0.1711 -0.382764,0.35419 -0.631825,0.54857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1105",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.477586,228.46577 c -0.324908,-1.9244 -1.23966,-3.7024 -2.59997,-5.08388 0.02468,0 0.04868,-3.4e-4 0.07303,-3.4e-4 1.607608,0 3.236028,0.40957 4.728278,1.27105 1.51483,0.87454 2.696634,2.10397 3.501322,3.5232 -0.783167,-0.20356 -1.586797,-0.30516 -2.390775,-0.30516 -1.122892,0 -2.246138,0.19862 -3.31188,0.59514"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1107",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.846136,235.45536 c -0.548569,-0.30621 -1.127477,-0.53658 -1.72226,-0.69074 -0.303035,-0.53446 -0.675923,-1.0347 -1.113367,-1.4852 0.118533,-0.2928 0.210257,-0.55739 0.272698,-0.79092 0.36336,-1.35643 0.413454,-2.72274 0.194379,-4.02273 1.065742,-0.39652 2.188988,-0.59514 3.31188,-0.59514 0.803978,0 1.607608,0.1016 2.390775,0.30516 0.956378,1.68663 1.379712,3.64066 1.19521,5.58341 -1.312685,0.12453 -2.619727,0.52599 -3.836459,1.22802 -0.208843,0.121 -0.440973,0.27834 -0.692856,0.46814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1109",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 61.678591,238.28816 c -0.32244,-0.57785 -0.729192,-1.12113 -1.220259,-1.61219 -0.491066,-0.49107 -1.034698,-0.89817 -1.612196,-1.22061 0.251883,-0.1898 0.484013,-0.34714 0.692856,-0.46814 1.216732,-0.70203 2.523774,-1.10349 3.836459,-1.22802 -0.124532,1.31198 -0.526698,2.61938 -1.228725,3.8354 -0.121002,0.20955 -0.27799,0.44133 -0.468135,0.69356"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1111",
    style: {
      fill: "#00095d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 48.444132,225.13837 c -0.81139,-1.77482 -2.155118,-3.25543 -3.826581,-4.23792 0.807863,-0.22331 1.650648,-0.34043 2.508604,-0.34043 0.811742,0 1.636184,0.10478 2.457802,0.32491 1.689452,0.45297 3.149248,1.33456 4.293659,2.49696 -1.938867,0.0152 -3.842809,0.62548 -5.433484,1.75648"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1113",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.893424,230.16369 c -0.851958,-0.81562 -1.900415,-1.42804 -3.067402,-1.7586 -0.04375,-0.31221 -0.09666,-0.58772 -0.159105,-0.82091 -0.36336,-1.35643 -1.0033,-2.5647 -1.84291,-3.58069 1.24319,-1.50425 2.924882,-2.58657 4.793544,-3.10304 1.671463,0.98249 3.015191,2.4631 3.826581,4.23792 -1.073856,0.76412 -2.005541,1.76601 -2.708275,2.98203 -0.274815,0.47625 -0.557035,1.1744 -0.842433,2.04329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1115",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.826022,228.40509 c -0.636413,-0.18027 -1.308455,-0.27693 -2.002721,-0.27693 -0.694619,0 -1.366309,0.0967 -2.002719,0.27693 0.04374,-0.31221 0.09666,-0.58737 0.159102,-0.82056 0.363715,-1.35643 1.004358,-2.56505 1.844323,-3.58104 0.83961,1.01599 1.47955,2.22426 1.84291,3.58069 0.06244,0.23319 0.115359,0.5087 0.159105,0.82091"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1117",
    style: {
      fill: "#3d778e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 52.541292,231.2767 c -0.590195,-0.14887 -1.189918,-0.22189 -1.78576,-0.22189 -0.591256,0 -1.178983,0.072 -1.749777,0.21166 0.187325,-0.89535 0.2921,-1.64218 0.2921,-2.19216 0,-1.40441 -0.305506,-2.7372 -0.853723,-3.93594 1.590675,-1.131 3.494617,-1.74131 5.433484,-1.75648 1.36031,1.38148 2.275062,3.15948 2.59997,5.08388 -1.235779,0.46002 -2.394654,1.18639 -3.388077,2.17946 -0.170743,0.17075 -0.354187,0.38277 -0.548217,0.63147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1119",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.494682,232.41441 c -0.38876,-0.84984 -0.93486,-1.61254 -1.601258,-2.25072 0.285398,-0.86889 0.567618,-1.56704 0.842433,-2.04329 0.702734,-1.21602 1.634419,-2.21791 2.708275,-2.98203 0.548217,1.19874 0.853723,2.53153 0.853723,3.93594 0,0.54998 -0.104775,1.29681 -0.2921,2.19216 -0.896056,0.21943 -1.749779,0.60643 -2.511073,1.14794"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1121",
    style: {
      fill: "#f5f5cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.010509,233.27942 c -0.461081,-0.47448 -0.994479,-0.89394 -1.595967,-1.24107 -0.601485,-0.34713 -1.231545,-0.59972 -1.87325,-0.76165 0.19403,-0.2487 0.377474,-0.46072 0.548217,-0.63147 0.993423,-0.99307 2.152298,-1.71944 3.388077,-2.17946 0.219075,1.29999 0.168981,2.6663 -0.194379,4.02273 -0.06244,0.23353 -0.154165,0.49812 -0.272698,0.79092"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1123",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.694641,229.77634 c -0.498827,-0.2734 -1.029052,-0.48966 -1.580799,-0.64206 0.529874,-0.31115 1.102784,-0.55809 1.70674,-0.72919 -0.05609,0.39935 -0.09772,0.85902 -0.125941,1.37125"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1125",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c 0.0032,-0.0258 2.909006,-22.45113 2.002721,-28.90556 1.166987,0.33056 2.215444,0.94298 3.067402,1.7586 -2.386894,7.26687 -4.976283,26.44775 -5.067652,27.12826 v 2.6e-4 c -7.94e-4,0.003 -0.0011,0.006 -0.0011,0.008 -2.65e-4,8e-4 -2.65e-4,0.002 -2.65e-4,0.002 v 2.6e-4 c -2.65e-4,2.6e-4 -2.65e-4,7.9e-4 -2.65e-4,10e-4 v 2.6e-4 c 0,2.7e-4 0,2.7e-4 0,2.7e-4 0,2.6e-4 0,2.6e-4 0,7.9e-4 -2.64e-4,7.9e-4 -2.64e-4,10e-4 -2.64e-4,10e-4 0,2.7e-4 0,2.7e-4 0,8e-4 v 0 c 0,2.6e-4 0,2.6e-4 0,7.9e-4 0,0 0,0 -2.65e-4,2.7e-4 0,2.6e-4 0,7.9e-4 0,7.9e-4 0,2.6e-4 0,2.6e-4 0,2.6e-4 v 2.7e-4 0 2.6e-4 0 0 c 0,2.7e-4 0,2.7e-4 0,2.7e-4 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1127",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 1.426988,-23.00358 c -0.539398,-2.01154 -1.86408,-3.60222 -3.555648,-4.53073 0.02822,-0.51223 0.06985,-0.9719 0.125941,-1.37125 0.63641,-0.18027 1.3081,-0.27693 2.002719,-0.27693 0.694266,0 1.366308,0.0967 2.002721,0.27693 0.906285,6.45443 -1.999546,28.8798 -2.002721,28.90556 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1129",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 m 0,-2.7e-4 v 0 0 m 0,0 v -2.6e-4 2.6e-4 m 0,-2.6e-4 v -2.7e-4 2.7e-4 m 0,-8e-4 c 0,0 0,-2.6e-4 0,-7.9e-4 0,2.6e-4 0,7.9e-4 0,7.9e-4 m 2.64e-4,-0.001 c 0,-2.6e-4 0,-2.6e-4 0,-7.9e-4 0,2.6e-4 0,2.6e-4 0,7.9e-4 m 0,-7.9e-4 c 0,-2.6e-4 0,-2.6e-4 0,-7.9e-4 0,2.6e-4 0,2.6e-4 0,7.9e-4 m 2.65e-4,-0.002 c 0,-2.6e-4 0,-2.6e-4 0,-7.9e-4 0,2.6e-4 0,2.6e-4 0,7.9e-4 m 0,-10e-4 v -2.7e-4 c 0,2.7e-4 0,2.7e-4 0,2.7e-4 m 2.65e-4,-10e-4 v -2.6e-4 2.6e-4 m 2.64e-4,-0.003 c 0,-0.002 2.65e-4,-0.005 0.0011,-0.008 -7.93e-4,0.003 -0.0011,0.006 -0.0011,0.008 m 0.0011,-0.008 c 0.09137,-0.68051 2.680759,-19.86139 5.067652,-27.12826 0.666398,0.63818 1.212498,1.40088 1.601259,2.25072 -0.831498,0.59126 -1.552223,1.36631 -2.095852,2.30752 -1.987905,3.44311 -4.483807,21.90433 -4.573059,22.57002"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1131",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.75318,230.16369 c -0.159808,-0.48719 -0.318913,-0.92075 -0.476604,-1.29187 0.627946,0.009 1.244954,0.0991 1.837266,0.26246 -0.493183,0.28999 -0.949676,0.63606 -1.360662,1.02941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1133",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 30.640777,231.26542 c -0.55245,-0.13512 -1.120351,-0.20673 -1.692626,-0.21097 0.431165,-0.43779 0.920115,-0.82408 1.459476,-1.14582 0.04918,0.40005 0.128129,0.85478 0.23315,1.35679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1135",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.152626,232.41371 c -0.761646,-0.54152 -1.615721,-0.92887 -2.511849,-1.14829 -0.105021,-0.50201 -0.183972,-0.95674 -0.23315,-1.35679 0.568007,-0.33902 1.192072,-0.60607 1.862349,-0.78563 0.636058,-0.1704 1.27494,-0.25189 1.903238,-0.25189 0.03457,0 0.06879,0 0.103362,7.2e-4 0.157691,0.37112 0.316796,0.80468 0.476604,1.29187 -0.666046,0.63817 -1.212146,1.40053 -1.600554,2.25002"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1137",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c -0.0032,-0.0215 -2.641246,-19.75238 -5.070121,-27.14696 0.410986,-0.39335 0.867479,-0.73942 1.360662,-1.02941 0.551747,0.1524 1.081972,0.36866 1.580799,0.64206 -0.432507,7.77134 2.125839,27.51279 2.12866,27.53431"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1139",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 l -4.575527,-22.58907 c -0.543277,-0.94121 -1.264002,-1.71662 -2.095148,-2.30787 0.388408,-0.84949 0.934508,-1.61184 1.600554,-2.25002 2.428875,7.39458 5.066946,27.12544 5.070121,27.14696 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1141",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 c -0.0028,-0.0215 -2.561167,-19.76297 -2.12866,-27.53431 1.691568,0.92851 3.01625,2.51919 3.555648,4.53073 l -1.426988,23.00358 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1143",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 27.900013,232.40101 c -0.280706,-0.42933 -0.5467,-0.80716 -0.794738,-1.12466 0.590515,-0.14922 1.190343,-0.22225 1.786644,-0.22225 0.0186,0 0.03747,3.5e-4 0.05623,3.5e-4 -0.401567,0.40781 -0.75311,0.86042 -1.048138,1.34655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1145",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 22.522903,234.76391 c 0.303283,-0.53481 0.675499,-1.03434 1.113297,-1.48484 0.151059,0.37359 0.345087,0.79269 0.57658,1.2506 -0.568431,0.0123 -1.136192,0.0903 -1.689877,0.23424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1147",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.935906,234.98863 c -0.825006,-0.30727 -1.694003,-0.46073 -2.563283,-0.46073 -0.0533,0 -0.106503,7.2e-4 -0.159843,0.002 -0.231493,-0.45791 -0.425521,-0.87701 -0.57658,-1.2506 0.461115,-0.47449 0.994833,-0.89394 1.596037,-1.24107 0.601239,-0.34714 1.231582,-0.59972 1.873038,-0.76165 0.248038,0.3175 0.514032,0.69533 0.794738,1.12466 -0.478473,0.78845 -0.808637,1.66652 -0.964107,2.58762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1149",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c 0,0 0,0 -2.65e-4,-2.7e-4 v 0 -2.6e-4 -2.7e-4 c -2.64e-4,0 -2.64e-4,-2.6e-4 -2.64e-4,-7.9e-4 -2.65e-4,-2.7e-4 -2.65e-4,-2.7e-4 -2.65e-4,-8e-4 v 0 c -2.65e-4,-2.6e-4 -2.65e-4,-2.6e-4 -2.65e-4,-7.9e-4 -2.64e-4,-2.6e-4 -2.64e-4,-0.001 -7.93e-4,-0.002 0,0 0,0 0,-2.7e-4 -0.144992,-0.34748 -7.700079,-18.44957 -11.921172,-24.90434 0.295028,-0.48613 0.646572,-0.93874 1.048138,-1.34656 0.572275,0.004 1.140177,0.0759 1.692627,0.21097 1.579105,7.54732 9.032946,25.68187 9.180055,26.03993 2.64e-4,0 2.64e-4,2.7e-4 2.64e-4,2.7e-4 v 2.6e-4 c 2.65e-4,2.7e-4 2.65e-4,8e-4 7.94e-4,0.001 0,2.7e-4 0,7.9e-4 2.65e-4,10e-4 v 2.6e-4 c 0,0 0,2.7e-4 2.64e-4,2.7e-4 0,2.6e-4 2.65e-4,10e-4 2.65e-4,10e-4 0,2.6e-4 0,2.6e-4 0,2.6e-4 v 0 c 0,2.7e-4 2.64e-4,2.7e-4 2.64e-4,2.7e-4 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1151",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c 0,0 -2.65e-4,0 -2.65e-4,-2.7e-4 0,2.7e-4 2.65e-4,2.7e-4 2.65e-4,2.7e-4 m -2.65e-4,-2.7e-4 c 0,0 0,0 0,-2.6e-4 0,2.6e-4 0,2.6e-4 0,2.6e-4 m -2.64e-4,-0.001 c -2.65e-4,0 -2.65e-4,-2.7e-4 -2.65e-4,-2.7e-4 0,0 0,2.7e-4 2.65e-4,2.7e-4 m -2.65e-4,-8e-4 c -2.65e-4,-2.6e-4 -2.65e-4,-7.9e-4 -2.65e-4,-0.001 0,2.6e-4 0,7.9e-4 2.65e-4,0.001 m -0.0011,-0.002 v -2.7e-4 2.7e-4 m -2.65e-4,-8e-4 c -0.147108,-0.35806 -7.60095,-18.49261 -9.180055,-26.03993 0.896128,0.21942 1.750203,0.60677 2.511849,1.14829 -0.424392,0.9278 -0.661104,1.95932 -0.661104,3.04623 0,4.00897 7.185729,21.49581 7.32931,21.84541"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1153",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 c 0,0 0,0 -2.65e-4,-2.7e-4 2.65e-4,2.7e-4 2.65e-4,2.7e-4 2.65e-4,2.7e-4 v 0 0 m -2.65e-4,-2.7e-4 v -2.6e-4 2.6e-4 m 0,-7.9e-4 c -2.64e-4,0 -2.64e-4,-2.7e-4 -2.64e-4,-8e-4 0,2.7e-4 0,8e-4 2.64e-4,8e-4 m -7.94e-4,-0.001 v 0 0 m -2.64e-4,-7.9e-4 c -2.65e-4,-2.6e-4 -2.65e-4,-10e-4 -7.94e-4,-0.002 2.65e-4,7.9e-4 2.65e-4,0.001 7.94e-4,0.002 m -7.94e-4,-0.002 c -0.143227,-0.34254 -7.428793,-17.79517 -10.264103,-20.62973 -0.768387,-0.76871 -1.665217,-1.33104 -2.621175,-1.68699 0.15547,-0.9211 0.485634,-1.79916 0.964107,-2.58762 4.221092,6.45477 11.776179,24.55686 11.921171,24.90434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1155",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822949,257.31029 v 0 0 m 0,-2.6e-4 c 0,0 -2.65e-4,-7.9e-4 -2.65e-4,-10e-4 0,2.7e-4 2.65e-4,10e-4 2.65e-4,10e-4 m -7.94e-4,-10e-4 v -2.7e-4 2.7e-4 m -2.64e-4,-0.001 c -2.65e-4,-2.6e-4 -2.65e-4,-7.9e-4 -7.94e-4,-10e-4 2.64e-4,2.7e-4 2.64e-4,8e-4 7.94e-4,10e-4 m -7.94e-4,-10e-4 c 0,0 0,-2.6e-4 -2.65e-4,-2.6e-4 2.65e-4,0 2.65e-4,2.6e-4 2.65e-4,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1157",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 c 0,0 -2.65e-4,0 -2.65e-4,-2.7e-4 v 0 c 0,0 0,0 0,-2.6e-4 0,0 -2.64e-4,-8e-4 -2.64e-4,-10e-4 -2.65e-4,0 -2.65e-4,-2.7e-4 -2.65e-4,-2.7e-4 v -2.6e-4 c -2.65e-4,-2.7e-4 -2.65e-4,-8e-4 -2.65e-4,-10e-4 -2.64e-4,-2.6e-4 -2.64e-4,-7.9e-4 -7.93e-4,-10e-4 v -2.6e-4 c 0,0 0,-2.7e-4 -2.65e-4,-2.7e-4 -0.143581,-0.3496 -7.32931,-17.83644 -7.32931,-21.84541 0,-1.08691 0.236712,-2.11843 0.661104,-3.04623 0.831146,0.59125 1.551871,1.36666 2.095148,2.30787 l 4.575527,22.58906"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1159",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 21.859222,236.33554 c -0.382411,-0.3422 -0.736952,-0.63818 -1.058862,-0.88054 0.548429,-0.30621 1.127619,-0.53657 1.722543,-0.69109 -0.282363,0.49777 -0.504648,1.02553 -0.663681,1.57163"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1161",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 17.276851,240.00972 c 0.154587,-0.59514 0.384739,-1.17405 0.691092,-1.72226 0.242534,0.32173 0.538374,0.67627 0.880533,1.05868 -0.5461,0.15911 -1.07375,0.38136 -1.571625,0.66358"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1163",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 18.848476,239.34614 c -0.342159,-0.38241 -0.637999,-0.73695 -0.880533,-1.05868 0.322438,-0.5775 0.729227,-1.12113 1.220082,-1.61184 0.491137,-0.49107 1.03452,-0.89818 1.612335,-1.22062 0.32191,0.24236 0.676451,0.53834 1.058862,0.88054 -0.258092,0.88547 -0.349884,1.81892 -0.261549,2.74919 -0.230258,-0.0219 -0.460939,-0.0328 -0.690809,-0.0328 -0.698677,0 -1.392097,0.0998 -2.058388,0.29421"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1165",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 h -2.65e-4 c 0,-2.7e-4 0,-2.7e-4 -2.64e-4,-8e-4 -0.09701,-0.12629 -12.182899,-15.80303 -17.963375,-20.9744 0.159032,-0.5461 0.381318,-1.07386 0.663681,-1.57162 0.553685,-0.14394 1.121445,-0.2219 1.689876,-0.23425 3.482446,6.88904 15.398151,22.50299 15.607701,22.7771 0,2.6e-4 2.65e-4,7.9e-4 7.94e-4,0.001 7.93e-4,10e-4 0.0013,0.002 0.0019,0.002 v 0 c 0,2.6e-4 2.64e-4,2.6e-4 2.64e-4,2.6e-4 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1167",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c 0,0 -2.65e-4,0 -2.65e-4,-2.7e-4 0,2.7e-4 2.65e-4,2.7e-4 2.65e-4,2.7e-4 m -2.65e-4,-2.7e-4 c -2.64e-4,-2.6e-4 -0.0011,-0.001 -0.0019,-0.002 7.94e-4,10e-4 0.0013,0.002 0.0019,0.002 m -0.0024,-0.004 c -0.20955,-0.27411 -12.125255,-15.88805 -15.607701,-22.77709 0.05334,-0.001 0.106539,-0.002 0.159844,-0.002 0.869279,0 1.738277,0.15346 2.563283,0.46073 -0.169757,1.00612 -0.131304,2.06375 0.150072,3.11362 1.038648,3.87632 12.528127,18.93464 12.734502,19.20451"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1169",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 c 0,0 0,0 -2.65e-4,0 h 2.65e-4 v 0 0 m -7.94e-4,-8e-4 c -0.09525,-0.12382 -11.763834,-15.25834 -15.256334,-17.27447 -0.941493,-0.54327 -1.952978,-0.85442 -2.96859,-0.95073 -0.08833,-0.93028 0.0035,-1.86373 0.26155,-2.7492 5.780475,5.17137 17.866359,20.84811 17.963374,20.9744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1171",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822949,257.31029 v 0 0 m 0,-2.6e-4 v -2.7e-4 2.7e-4 m -2.65e-4,-10e-4 c -2.64e-4,-2.6e-4 -2.64e-4,-2.6e-4 -2.64e-4,-7.9e-4 0,2.6e-4 0,2.6e-4 2.64e-4,7.9e-4 m -2.64e-4,-7.9e-4 c -2.65e-4,-2.7e-4 -2.65e-4,-2.7e-4 -2.65e-4,-8e-4 0,2.7e-4 0,2.7e-4 2.65e-4,8e-4 m -0.0011,-0.002 c 0,0 0,0 0,-2.7e-4 0,2.7e-4 0,2.7e-4 0,2.7e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1173",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822949,257.31029 v 0 0 m -0.0019,-0.002 c -2.65e-4,-2.6e-4 -7.94e-4,-7.9e-4 -7.94e-4,-10e-4 0,2.7e-4 2.65e-4,8e-4 7.94e-4,10e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1175",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 c 0,0 -2.65e-4,0 -2.65e-4,-2.7e-4 v 0 c -2.64e-4,-2.6e-4 -0.0011,-0.001 -0.0019,-0.002 -2.64e-4,-2.7e-4 -7.94e-4,-7.9e-4 -7.94e-4,-10e-4 -0.206375,-0.26987 -11.695853,-15.32819 -12.734502,-19.20451 -0.281375,-1.04987 -0.319828,-2.1075 -0.150071,-3.11362 0.955957,0.35595 1.852787,0.91828 2.621174,1.68698 2.83531,2.83457 10.120876,20.28719 10.264103,20.62974 0,2.7e-4 0,2.7e-4 0,2.7e-4 2.65e-4,7.9e-4 2.65e-4,10e-4 7.94e-4,0.002 0,2.6e-4 0,2.6e-4 2.64e-4,7.9e-4 v 0 c 0,2.7e-4 0,2.7e-4 2.65e-4,8e-4 0,2.6e-4 0,7.9e-4 2.65e-4,7.9e-4 v 2.6e-4 2.7e-4 0 c 2.64e-4,2.6e-4 2.64e-4,2.6e-4 2.64e-4,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1177",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1179",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 17.042571,241.69988 c -0.457905,-0.23143 -0.87697,-0.42581 -1.250703,-0.5768 0.450356,-0.43779 0.950278,-0.80997 1.484983,-1.11336 -0.143863,0.55386 -0.221862,1.12148 -0.23428,1.69016"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1181",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 c -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 v -2.7e-4 c -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 -2.65e-4,0 -7.94e-4,-2.6e-4 -0.0011,-2.6e-4 -2.64e-4,0 -2.64e-4,0 -2.64e-4,-2.7e-4 h -2.65e-4 c -0.240948,-0.0991 -18.470527,-7.59742 -26.042408,-9.18175 -0.280458,-1.14547 -0.286491,-2.36008 0.01058,-3.53553 5.102543,3.98542 25.737962,12.5946 26.030766,12.71667 0,0 2.64e-4,2.6e-4 7.94e-4,2.6e-4 v 0 c 2.64e-4,0 2.64e-4,2.6e-4 7.93e-4,2.6e-4 2.65e-4,0 2.65e-4,2.7e-4 7.94e-4,2.7e-4 0,0 0,0 2.65e-4,0 l 2.64e-4,2.6e-4 v 0 c 0,0 0,0 2.65e-4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1183",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 c -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 h 2.65e-4 v 0 m -2.65e-4,0 -2.64e-4,-2.7e-4 2.64e-4,2.7e-4 m -7.94e-4,-2.7e-4 c -2.64e-4,0 -2.64e-4,-2.6e-4 -7.93e-4,-2.6e-4 2.64e-4,0 2.64e-4,2.6e-4 7.93e-4,2.6e-4 m -0.0013,-7.9e-4 v 0 0 m -7.94e-4,-2.7e-4 c -0.292804,-0.12206 -20.928223,-8.73125 -26.031118,-12.71693 0.162066,-0.6417 0.414408,-1.27141 0.761647,-1.8729 0.347133,-0.60148 0.766763,-1.13524 1.241213,-1.59632 0.373733,0.15099 0.792798,0.34537 1.250703,0.57679 -0.04187,1.92935 0.673171,3.87174 2.145454,5.34423 2.84166,2.84119 20.36258,10.15286 20.632101,10.26505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1185",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 0,0 0,0 2.65e-4,0 m -2.65e-4,-2.7e-4 c -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 0,0 0,0 2.64e-4,0 m -0.0013,-2.6e-4 c -2.64e-4,0 -2.64e-4,0 -2.64e-4,-2.7e-4 0,2.7e-4 0,2.7e-4 2.64e-4,2.7e-4 m -7.93e-4,-2.7e-4 c -0.236009,-0.097 -17.826285,-7.33107 -21.848233,-7.33072 -2.47e-4,0 -3.97e-4,0 -5.29e-4,0 -1.086591,0 -2.118043,0.23636 -3.04546,0.6604 -0.541444,-0.7613 -0.928829,-1.61537 -1.148186,-2.51143 7.571881,1.58433 25.801459,9.08262 26.042408,9.18175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1187",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c 0,0 -15.830725,-12.09746 -22.78073,-15.61077 0.01242,-0.56868 0.09042,-1.1363 0.23428,-1.69016 0.497875,-0.28222 1.025525,-0.50447 1.571625,-0.66358 5.13775,5.74252 20.642156,17.70804 20.969533,17.96027 v 0 c 2.65e-4,2.7e-4 7.94e-4,8e-4 0.0011,10e-4 2.65e-4,0 2.65e-4,2.6e-4 2.65e-4,2.6e-4 v 0 c 7.94e-4,2.7e-4 0.0011,8e-4 0.0013,0.001 7.94e-4,8e-4 0.0013,10e-4 0.0019,10e-4 v 0 h 2.65e-4 v 2.6e-4 c 2.64e-4,0 2.64e-4,0 2.64e-4,0 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1189",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c 0,0 0,0 -2.65e-4,0 2.65e-4,0 2.65e-4,0 2.65e-4,0 v 0 m -2.65e-4,-2.7e-4 h -2.64e-4 2.64e-4 m -2.64e-4,0 c -2.65e-4,-2.6e-4 -0.0011,-7.9e-4 -0.0019,-0.001 7.93e-4,7.9e-4 0.0013,0.001 0.0019,0.001 m -0.0032,-0.002 v 0 0 m -2.65e-4,-2.7e-4 c -2.65e-4,-2.6e-4 -7.94e-4,-7.9e-4 -0.0011,-10e-4 2.64e-4,2.6e-4 7.93e-4,7.9e-4 0.0011,10e-4 m -0.0011,-10e-4 c -0.327642,-0.2525 -15.832048,-12.21802 -20.969798,-17.96054 0.666291,-0.19438 1.359711,-0.29421 2.058388,-0.29421 0.22987,0 0.460551,0.0109 0.690809,0.0328 0.09634,1.01565 0.407353,2.02742 0.950701,2.96863 2.003002,3.46922 16.948608,15.00575 17.269635,15.25305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1191",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822949,257.31065 v 0 0 m -2.65e-4,-2.7e-4 c -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 0,0 0,0 2.64e-4,0 m -0.0011,-2.6e-4 c -2.65e-4,0 -2.65e-4,-2.7e-4 -7.94e-4,-2.7e-4 2.65e-4,0 2.65e-4,2.7e-4 7.94e-4,2.7e-4 m -7.94e-4,-2.7e-4 c -2.64e-4,0 -7.94e-4,-2.6e-4 -7.94e-4,-2.6e-4 0,0 2.65e-4,2.6e-4 7.94e-4,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1193",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 h -2.65e-4 v 0 l -2.64e-4,-2.7e-4 c -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -2.65e-4,-2.6e-4 -7.94e-4,-2.6e-4 -2.64e-4,0 -2.64e-4,-2.7e-4 -7.93e-4,-2.7e-4 v 0 c -2.65e-4,0 -7.94e-4,-2.6e-4 -7.94e-4,-2.6e-4 -0.269521,-0.11254 -17.790441,-7.42421 -20.632101,-10.26548 -1.472283,-1.4725 -2.187328,-3.41489 -2.145454,-5.34423 6.950005,3.51331 22.78073,15.61077 22.78073,15.61077 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1195",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822949,257.31065 c 0,-2.7e-4 0,-2.7e-4 -2.65e-4,-8e-4 2.65e-4,2.7e-4 2.65e-4,2.7e-4 2.65e-4,8e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1197",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822949,257.31065 v -2.7e-4 2.7e-4 m -2.65e-4,-2.7e-4 v 0 0 m -0.0019,-0.001 c -2.64e-4,-2.7e-4 -7.94e-4,-8e-4 -0.0013,-10e-4 7.94e-4,2.6e-4 0.0011,7.9e-4 0.0013,10e-4 m -0.0013,-10e-4 c 0,0 0,-2.7e-4 -2.64e-4,-2.7e-4 2.64e-4,0 2.64e-4,2.7e-4 2.64e-4,2.7e-4 m -0.0013,-10e-4 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1199",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c 0,0 0,0 -2.65e-4,0 v -2.7e-4 h -2.64e-4 v 0 c -2.65e-4,-2.6e-4 -0.0011,-7.9e-4 -0.0019,-0.001 -2.65e-4,-2.7e-4 -7.94e-4,-8e-4 -0.0013,-10e-4 v 0 c 0,0 0,-2.7e-4 -2.65e-4,-2.7e-4 -2.65e-4,-2.6e-4 -7.94e-4,-7.9e-4 -0.0011,-10e-4 v 0 c -0.321027,-0.2473 -15.266634,-11.78384 -17.269635,-15.25306 -0.543349,-0.94121 -0.854358,-1.95297 -0.950701,-2.96862 1.015612,0.0963 2.027096,0.40746 2.96859,0.95074 3.492499,2.01612 15.161084,17.15064 15.256334,17.27446 2.64e-4,2.7e-4 2.64e-4,2.7e-4 2.64e-4,8e-4 2.65e-4,0 2.65e-4,0 2.65e-4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1201",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822949,257.31065 c 0,0 0,0 -2.65e-4,0 -2.64e-4,0 -0.0013,-2.7e-4 -0.0032,-8e-4 h -2.64e-4 c -7.94e-4,0 -0.0013,0 -0.0024,-2.6e-4 0,0 -2.64e-4,0 -7.93e-4,0 -0.391936,-0.0505 -16.899289,-2.17735 -25.508443,-2.17735 -1.357771,0 -2.519186,0.0529 -3.3897,0.17533 0.330446,-1.16699 0.942727,-2.21544 1.758526,-3.0674 7.313225,2.40171 26.690531,5.00909 27.138913,5.06942 h 2.65e-4 c 0.0011,0 0.0024,2.6e-4 0.0035,2.6e-4 7.94e-4,2.7e-4 0.0011,2.7e-4 0.0019,2.7e-4 v 0 c 2.64e-4,0 2.64e-4,0 7.93e-4,0 v 0 h 2.65e-4 c 0,0 2.64e-4,0 2.64e-4,2.6e-4 h 2.65e-4 c 2.65e-4,0 2.65e-4,0 2.65e-4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1203",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822949,257.31065 v 0 c 0,0 0,0 -2.65e-4,0 2.65e-4,0 2.65e-4,0 2.65e-4,0 m -7.94e-4,0 c 0,-2.7e-4 -2.64e-4,-2.7e-4 -2.64e-4,-2.7e-4 0,0 2.64e-4,0 2.64e-4,2.7e-4 m -7.94e-4,-2.7e-4 v 0 0 m -7.93e-4,0 v 0 0 m -0.0019,-2.6e-4 c -0.0011,0 -0.0024,-2.7e-4 -0.0035,-2.7e-4 0.0011,0 0.0024,2.7e-4 0.0035,2.7e-4 m -0.0039,-2.7e-4 c -0.448381,-0.0603 -19.825688,-2.6677 -27.138912,-5.06942 0.638139,-0.66639 1.400492,-1.21249 2.250334,-1.6009 0.591291,0.8315 1.366449,1.55187 2.307801,2.0955 3.465477,2.0006 22.141214,4.51591 22.580777,4.57482"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1205",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 11.647011,261.0194 c -0.311291,-0.52952 -0.558129,-1.10208 -0.729262,-1.70604 0.399203,0.0557 0.858943,0.0974 1.371142,0.12595 -0.273544,0.49847 -0.489621,1.0287 -0.64188,1.58009"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1207",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 12.288891,259.43931 c -0.512199,-0.0286 -0.971939,-0.0702 -1.371142,-0.12595 -0.180375,-0.63676 -0.277001,-1.3088 -0.277001,-2.00307 0,-0.69426 0.09663,-1.3663 0.277001,-2.00272 0.870515,-0.12241 2.03193,-0.17533 3.389701,-0.17533 8.609153,0 25.116507,2.1269 25.508442,2.17735 -0.345368,-0.0445 -13.088336,-1.68452 -19.738621,-1.68452 -1.42695,0 -2.574572,0.0755 -3.257655,0.25859 -2.011398,0.53904 -3.602355,1.86373 -4.530725,3.55565 m 27.533706,-2.12866 c -2.65e-4,0 -0.0013,-2.7e-4 -0.0032,-8e-4 0.0019,2.7e-4 0.0028,8e-4 0.0032,8e-4 m -0.0035,-8e-4 c -7.94e-4,0 -0.0013,0 -0.0024,-2.6e-4 0.0011,2.6e-4 0.0019,2.6e-4 0.0024,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1209",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822949,257.31065 c 0,0 0,0 0,-2.7e-4 v 2.7e-4 m -2.65e-4,-2.7e-4 c -2.64e-4,0 -7.93e-4,-2.6e-4 -0.0011,-2.6e-4 2.65e-4,0 7.94e-4,2.6e-4 0.0011,2.6e-4 m -0.0013,-7.9e-4 h -2.64e-4 2.64e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1211",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1213",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822597,257.31065 h -2.65e-4 2.65e-4 m -7.94e-4,-2.7e-4 h -2.64e-4 2.64e-4 m -2.64e-4,0 c -2.65e-4,0 -2.65e-4,0 -7.94e-4,0 2.64e-4,0 2.64e-4,0 7.94e-4,0 m -7.94e-4,0 c -7.94e-4,0 -0.0011,0 -0.0019,-2.6e-4 7.94e-4,2.6e-4 0.0011,2.6e-4 0.0019,2.6e-4 m -0.0053,-7.9e-4 h -2.64e-4 c 2.64e-4,0 2.64e-4,0 2.64e-4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1215",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 c 0,0 0,0 -2.65e-4,0 0,0 0,0 -2.64e-4,0 h -2.65e-4 c 0,-2.7e-4 -2.65e-4,-2.7e-4 -2.65e-4,-2.7e-4 h -2.64e-4 v 0 c -2.65e-4,0 -2.65e-4,0 -7.94e-4,0 v 0 c -7.94e-4,0 -0.0011,0 -0.0019,-2.6e-4 -0.0011,0 -0.0024,-2.7e-4 -0.0035,-2.7e-4 0,0 0,0 -2.65e-4,0 -0.439562,-0.0589 -19.115299,-2.57422 -22.580776,-4.57482 -0.941353,-0.54363 -1.716511,-1.264 -2.307802,-2.0955 0.927418,-0.42404 1.958869,-0.6604 3.04546,-0.6604 1.41e-4,0 2.91e-4,0 5.29e-4,0 4.021949,-2.7e-4 21.612225,7.23371 21.848233,7.33072 h 2.65e-4 c 0,2.7e-4 0,2.7e-4 2.64e-4,2.7e-4 2.65e-4,0 7.94e-4,2.6e-4 0.0011,2.6e-4 0,0 0,0 2.64e-4,0 0,2.7e-4 0,2.7e-4 0,2.7e-4 0,0 0,0 2.65e-4,0 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1217",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 11.384227,262.85737 c 0.0089,-0.6283 0.09906,-1.24531 0.262784,-1.83797 0.290054,0.49389 0.635953,0.95003 1.029512,1.36101 -0.487398,0.16017 -0.92135,0.31927 -1.292296,0.47696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1219",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 13.566899,268.18573 c -0.437832,-0.4311 -0.82423,-0.9204 -1.145999,-1.45944 0.400192,-0.0494 0.854957,-0.12806 1.357101,-0.23319 -0.135184,0.5521 -0.206551,1.12042 -0.211102,1.69263"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1221",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 12.4209,266.72629 c -0.338984,-0.56833 -0.606037,-1.19239 -0.785883,-1.86303 -0.179705,-0.67062 -0.260315,-1.34443 -0.25079,-2.00589 0.370946,-0.15769 0.804898,-0.31679 1.292296,-0.47696 0.637893,0.66605 1.400387,1.2125 2.249805,1.60091 -0.541725,0.76129 -0.928934,1.61537 -1.148327,2.51178 -0.502144,0.10513 -0.956909,0.1838 -1.357101,0.23319"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1223",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c 0,0 -2.65e-4,0 -7.94e-4,0 2.65e-4,0 2.65e-4,0 2.65e-4,0 2.64e-4,0 2.64e-4,0 2.64e-4,0 v 0 m -0.0039,-8e-4 h -2.65e-4 2.65e-4 m -0.0028,-2.6e-4 c 0,0 -2.65e-4,0 -7.94e-4,0 2.65e-4,0 7.94e-4,0 7.94e-4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1225",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822949,257.31065 h 5.29e-4 v 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1227",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 12.676523,262.38041 c -0.393559,-0.41098 -0.739458,-0.86712 -1.029512,-1.36101 0.152259,-0.55139 0.368336,-1.08162 0.64188,-1.58009 0.605084,0.0335 1.282665,0.049 2.017853,0.049 8.713223,0 25.516557,-2.17769 25.516557,-2.17769 v 0 h -2.65e-4 v 0 c -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 v 0 c -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 h -2.65e-4 c -2.64e-4,0 -7.93e-4,2.6e-4 -0.0011,2.6e-4 0,0 0,0 -2.64e-4,0 0,0 0,0 -2.65e-4,0 v 0 c -2.65e-4,0 -2.65e-4,0 -7.94e-4,0 -2.64e-4,0 -0.0011,2.6e-4 -0.0013,2.6e-4 -2.64e-4,0 -2.64e-4,0 -7.93e-4,0 h -2.65e-4 -2.65e-4 c -2.64e-4,0 -2.64e-4,2.7e-4 -7.93e-4,2.7e-4 -7.94e-4,0 -0.0019,0 -0.0024,2.6e-4 -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 -0.50518,0.0677 -19.834719,2.67018 -27.136549,5.06836"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1229",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 14.306744,259.48834 c -0.735188,0 -1.412769,-0.0155 -2.017853,-0.049 0.92837,-1.69192 2.519327,-3.01661 4.530725,-3.55565 0.683083,-0.18309 1.830705,-0.25859 3.257655,-0.25859 6.650285,0 19.393253,1.64007 19.738621,1.68452 2.65e-4,0 7.94e-4,0 7.94e-4,0 0.0011,2.6e-4 0.0019,2.6e-4 0.0024,2.6e-4 h 2.65e-4 c 0.0019,2.7e-4 0.0028,8e-4 0.0032,8e-4 2.65e-4,0 7.94e-4,0 7.94e-4,0 v 0 c 0,0 -16.803334,2.17769 -25.516557,2.17769"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1231",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 14.926328,263.98132 c -0.849418,-0.38841 -1.611912,-0.93486 -2.249805,-1.60091 7.30183,-2.39818 26.631369,-5.00062 27.136549,-5.06835 -0.497065,0.0667 -19.119533,2.57633 -22.578942,4.57447 -0.941352,0.54292 -1.716617,1.26365 -2.307802,2.09479 m 24.887096,-6.66926 c 7.94e-4,-2.7e-4 0.0019,-2.7e-4 0.0024,-2.7e-4 -7.94e-4,0 -0.0019,0 -0.0024,2.7e-4 m 0.0032,-8e-4 h 2.64e-4 -2.64e-4 m 7.94e-4,0 c 2.64e-4,0 2.64e-4,0 7.93e-4,0 -2.64e-4,0 -2.64e-4,0 -7.93e-4,0 m 0.0021,-2.6e-4 c 2.65e-4,0 2.65e-4,0 7.94e-4,0 -2.65e-4,0 -2.65e-4,0 -7.94e-4,0 m 7.94e-4,0 c 2.65e-4,0 2.65e-4,0 2.65e-4,0 0,0 0,0 -2.65e-4,0 m 7.94e-4,0 c 2.64e-4,0 7.94e-4,-2.7e-4 0.0011,-2.7e-4 -2.64e-4,0 -7.94e-4,2.7e-4 -0.0011,2.7e-4 m 0.0013,-2.7e-4 c 0,0 0,0 2.64e-4,0 -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 m 2.64e-4,0 c 0,0 0,0 2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 m 2.65e-4,0 h 2.64e-4 v 0 0 h -2.64e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1233",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c 0,0 0,0 -2.65e-4,0 2.65e-4,0 2.65e-4,0 2.65e-4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1235",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 13.788761,270.02867 c -0.154093,-0.60935 -0.226554,-1.22805 -0.221862,-1.84294 0.408023,0.40146 0.860284,0.75282 1.346729,1.0481 -0.429366,0.28085 -0.807226,0.54681 -1.124867,0.79484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1237",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 18.84837,275.27444 c -1.132628,-0.32988 -2.186834,-0.93168 -3.056784,-1.77655 5.954219,-2.40704 23.486673,-15.77132 24.019015,-16.17772 0.0011,-7.9e-4 0.0021,-0.001 0.0028,-0.002 l 2.64e-4,-2.6e-4 c 2.65e-4,0 7.94e-4,-2.7e-4 0.0011,-7.9e-4 2.64e-4,-2.7e-4 7.93e-4,-8e-4 0.0013,-10e-4 0.0011,-8e-4 0.0019,-0.001 0.0028,-0.002 2.64e-4,-2.6e-4 7.93e-4,-2.6e-4 7.93e-4,-7.9e-4 2.65e-4,-2.7e-4 7.94e-4,-2.7e-4 0.0011,-8e-4 0,0 2.64e-4,-2.6e-4 7.94e-4,-2.6e-4 v -2.7e-4 c 2.64e-4,0 7.93e-4,-2.6e-4 0.0011,-7.9e-4 v 0 c 0,0 2.64e-4,0 2.64e-4,-2.6e-4 v 0 c 0,0 0,0 2.65e-4,0 v 0 c -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 v 0 c -2.64e-4,2.6e-4 -2.64e-4,2.6e-4 -7.93e-4,7.9e-4 v 0 c -2.65e-4,0 -2.65e-4,2.6e-4 -2.65e-4,2.6e-4 v 0 c -2.64e-4,0 -2.64e-4,2.7e-4 -7.94e-4,2.7e-4 0,0 0,0 0,2.6e-4 -2.64e-4,0 -7.93e-4,2.7e-4 -0.0011,8e-4 -2.65e-4,0 -7.94e-4,2.6e-4 -0.0011,2.6e-4 -0.283634,0.21872 -15.825681,12.21031 -20.970697,17.96097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1239",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 15.791586,273.49789 c -0.474451,-0.46151 -0.89408,-0.99494 -1.241319,-1.59632 -0.347133,-0.60124 -0.599475,-1.23155 -0.761506,-1.8729 0.317641,-0.24803 0.695501,-0.51399 1.124867,-0.79484 1.128748,0.68432 2.439846,1.06535 3.799417,1.06535 0.627803,0 1.266401,-0.0812 1.901684,-0.25149 3.846935,-1.03082 18.705512,-12.35322 19.195872,-12.72752 -0.532342,0.4064 -18.064796,13.77068 -24.019015,16.17772 m 24.021838,-16.17984 2.64e-4,-2.6e-4 -2.64e-4,2.6e-4 m 0.0013,-0.001 c 2.64e-4,-2.7e-4 7.94e-4,-8e-4 0.0013,-10e-4 -7.94e-4,2.6e-4 -0.0011,7.9e-4 -0.0013,10e-4 m 0.0042,-0.003 c 2.65e-4,-2.6e-4 7.94e-4,-2.6e-4 7.94e-4,-7.9e-4 0,2.6e-4 -2.65e-4,2.6e-4 -7.94e-4,7.9e-4 m 0.0019,-0.001 c 0,0 2.65e-4,-2.7e-4 7.94e-4,-2.7e-4 -2.65e-4,0 -7.94e-4,2.7e-4 -7.94e-4,2.7e-4 m 7.94e-4,-8e-4 c 2.65e-4,0 7.94e-4,-2.6e-4 0.0011,-7.9e-4 -2.64e-4,2.6e-4 -7.93e-4,7.9e-4 -0.0011,7.9e-4 m 0.0011,-7.9e-4 c 0,0 2.65e-4,0 2.65e-4,-2.6e-4 0,2.6e-4 -2.65e-4,2.6e-4 -2.65e-4,2.6e-4 m 2.65e-4,-2.6e-4 c 0,0 0,0 2.64e-4,0 -2.64e-4,0 -2.64e-4,0 -2.64e-4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1241",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 20.907005,275.56866 c -0.698676,0 -1.392238,-0.10019 -2.058635,-0.29422 5.145017,-5.75066 20.687064,-17.74225 20.970697,-17.96097 -0.277635,0.21449 -15.265081,11.77995 -17.270693,15.25411 -0.543631,0.94121 -0.854639,1.95266 -0.951124,2.96827 -0.229976,0.0218 -0.460516,0.0328 -0.690245,0.0328 M 39.820126,257.3131 c 2.64e-4,-2.6e-4 7.94e-4,-7.9e-4 0.0011,-7.9e-4 -2.64e-4,0 -7.94e-4,2.6e-4 -0.0011,7.9e-4 m 0.0011,-0.001 c 2.65e-4,0 2.65e-4,-2.7e-4 7.94e-4,-2.7e-4 -2.65e-4,0 -2.65e-4,2.7e-4 -7.94e-4,2.7e-4 m 7.94e-4,-2.7e-4 c 0,0 0,-2.6e-4 2.64e-4,-2.6e-4 -2.64e-4,0 -2.64e-4,2.6e-4 -2.64e-4,2.6e-4 m 2.64e-4,-2.6e-4 c 2.65e-4,-2.7e-4 2.65e-4,-2.7e-4 7.94e-4,-8e-4 -2.64e-4,2.7e-4 -2.64e-4,2.7e-4 -7.94e-4,8e-4 m 7.94e-4,-8e-4 c 0,0 0,0 2.65e-4,0 v 0 0 0 h -2.65e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1243",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 14.913628,269.23383 c -0.486445,-0.29528 -0.938706,-0.64664 -1.346729,-1.0481 0.0046,-0.57221 0.07592,-1.14053 0.211102,-1.69263 7.532088,-1.57621 25.609266,-9.00324 26.03754,-9.17928 0,0 2.64e-4,-2.6e-4 7.93e-4,-2.6e-4 7.94e-4,-2.7e-4 0.0011,-2.7e-4 0.0019,-8e-4 v 0 c 7.94e-4,-2.6e-4 0.0011,-2.6e-4 0.0013,-7.9e-4 2.65e-4,0 7.94e-4,0 7.94e-4,-2.7e-4 2.65e-4,0 2.65e-4,0 2.65e-4,0 0,0 0,0 2.64e-4,0 l 2.65e-4,-2.6e-4 h 2.64e-4 c 0,0 0,0 2.65e-4,0 0,-2.7e-4 0,-2.7e-4 0,-2.7e-4 2.65e-4,0 2.65e-4,0 2.65e-4,0 2.64e-4,0 2.64e-4,-2.6e-4 7.93e-4,-2.6e-4 0,0 0,0 2.65e-4,0 v 0 c -0.02257,0.01 -18.39609,7.66339 -24.909673,11.92318"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1245",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 13.778001,266.4931 c 0.219393,-0.89641 0.606602,-1.75049 1.148327,-2.51178 0.9277,0.42439 1.959292,0.66111 3.046271,0.66111 4.000606,-2.7e-4 21.422431,-7.15575 21.842942,-7.32861 -0.428274,0.17604 -18.505452,7.60307 -26.03754,9.17928 m 26.038246,-9.17963 c 7.94e-4,-2.7e-4 0.0011,-2.7e-4 0.0019,-8e-4 -7.94e-4,2.7e-4 -0.0011,2.7e-4 -0.0019,8e-4 m 0.0019,-8e-4 c 7.94e-4,-2.6e-4 0.0011,-2.6e-4 0.0013,-7.9e-4 -2.65e-4,2.7e-4 -7.94e-4,2.7e-4 -0.0013,7.9e-4 m 0.0021,-0.001 h 2.64e-4 c 0,0 0,0 -2.64e-4,0 m 7.93e-4,0 2.65e-4,-2.7e-4 -2.65e-4,2.7e-4 m 7.94e-4,-2.7e-4 c 0,0 0,0 2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 m 2.65e-4,-2.6e-4 c 2.64e-4,0 2.64e-4,0 2.64e-4,0 0,0 0,0 -2.64e-4,0 m 0.0011,-2.7e-4 c 0,0 0,0 2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 m 2.65e-4,0 v 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1247",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.810601,257.32017 c 0.0011,-7.9e-4 0.0021,-0.001 0.0028,-0.002 -7.94e-4,8e-4 -0.0019,10e-4 -0.0028,0.002 m 0.0032,-0.002 c 2.64e-4,-2.7e-4 7.94e-4,-2.7e-4 0.0011,-7.9e-4 -2.64e-4,2.6e-4 -7.94e-4,7.9e-4 -0.0011,7.9e-4 m 0.0024,-0.002 c 0.0011,-8e-4 0.0019,-10e-4 0.0028,-0.002 -0.0011,7.9e-4 -0.0019,0.001 -0.0028,0.002 m 0.0035,-0.003 c 2.65e-4,-2.7e-4 7.94e-4,-2.7e-4 0.0011,-8e-4 -2.64e-4,2.7e-4 -7.93e-4,2.7e-4 -0.0011,8e-4 m 0.0019,-0.001 v -2.7e-4 2.7e-4 m 0.0011,-10e-4 v 0 0 m 2.65e-4,-2.7e-4 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1249",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 18.713045,270.29918 c -1.359571,0 -2.670669,-0.38103 -3.799417,-1.06535 6.513583,-4.25979 24.887096,-11.91366 24.909673,-11.92318 v 0 0 0 0 c -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 v 0 c 0,2.6e-4 -2.64e-4,2.6e-4 -2.64e-4,2.6e-4 v 0 c -2.65e-4,2.6e-4 -7.94e-4,7.9e-4 -0.0011,7.9e-4 v 2.7e-4 c -2.64e-4,0 -7.93e-4,2.6e-4 -7.93e-4,2.6e-4 -2.65e-4,2.7e-4 -7.94e-4,2.7e-4 -0.0011,8e-4 0,2.6e-4 -2.64e-4,2.6e-4 -7.94e-4,7.9e-4 -0.0011,7.9e-4 -0.0019,10e-4 -0.0028,0.002 -7.93e-4,2.6e-4 -0.0011,7.9e-4 -0.0013,0.001 -2.65e-4,2.6e-4 -7.94e-4,2.6e-4 -0.0011,7.9e-4 l -2.64e-4,2.6e-4 c -7.94e-4,8e-4 -0.0019,10e-4 -0.0028,0.002 -0.490361,0.3743 -15.348937,11.6967 -19.195873,12.72752 -0.635282,0.17032 -1.27388,0.25149 -1.901684,0.25149"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1251",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1253",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.813072,257.31206 c 0,0 0,0 2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 m 0.0028,-2.7e-4 c 2.65e-4,0 2.65e-4,-2.6e-4 7.94e-4,-2.6e-4 -2.65e-4,0 -2.65e-4,2.6e-4 -7.94e-4,2.6e-4 m 0.0011,-2.6e-4 h 2.65e-4 -2.65e-4 m 0.0011,0 c 2.64e-4,0 0.0011,-2.7e-4 0.0013,-2.7e-4 -2.65e-4,0 -0.0011,2.7e-4 -0.0013,2.7e-4 m 0.0021,-2.7e-4 v 0 0 m 2.65e-4,0 c 2.65e-4,0 2.65e-4,0 2.65e-4,0 0,0 0,0 -2.65e-4,0 m 0.0013,-2.6e-4 h 2.64e-4 -2.64e-4 m 7.94e-4,0 v 0 0 m 2.64e-4,0 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1255",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.815541,257.31382 c 0,0 2.64e-4,-2.6e-4 7.93e-4,-2.6e-4 -2.64e-4,0 -7.93e-4,2.6e-4 -7.93e-4,2.6e-4 m 0.0024,-0.001 v 0 0 m 0.0013,-7.9e-4 c 2.64e-4,0 7.93e-4,0 7.93e-4,-2.7e-4 0,2.7e-4 -2.64e-4,2.7e-4 -7.93e-4,2.7e-4 m 0.0011,-2.7e-4 c 0,0 0,0 2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 m 7.94e-4,-2.6e-4 h 2.64e-4 -2.64e-4 m 7.94e-4,0 c 0,-2.7e-4 0,-2.7e-4 0,-2.7e-4 0,0 0,0 0,2.7e-4 m 2.64e-4,-2.7e-4 c 2.65e-4,0 2.65e-4,-2.6e-4 7.94e-4,-2.6e-4 -2.65e-4,0 -2.65e-4,2.6e-4 -7.94e-4,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1257",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 17.972599,264.64243 c -1.086979,0 -2.118571,-0.23672 -3.046271,-0.66111 0.591185,-0.83114 1.36645,-1.55187 2.307802,-2.09479 3.459409,-1.99814 22.081877,-4.5078 22.578942,-4.57447 0,0 0,0 2.65e-4,0 7.93e-4,-2.7e-4 0.0019,-2.7e-4 0.0024,-2.7e-4 2.64e-4,0 2.64e-4,-2.6e-4 7.94e-4,-2.6e-4 h 2.64e-4 2.65e-4 c 2.64e-4,0 2.64e-4,0 7.93e-4,0 2.65e-4,0 0.0011,-2.7e-4 0.0013,-2.7e-4 2.65e-4,0 2.65e-4,0 7.94e-4,0 v 0 c 2.65e-4,0 2.65e-4,0 2.65e-4,0 2.64e-4,0 2.64e-4,0 2.64e-4,0 2.65e-4,0 7.94e-4,-2.6e-4 0.0011,-2.6e-4 h 2.64e-4 c 0,0 0,0 2.65e-4,0 v 0 c 0,0 0,0 2.64e-4,0 v 0 h 2.65e-4 v 0 0 c -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -2.64e-4,0 -2.64e-4,2.6e-4 -7.93e-4,2.6e-4 0,0 0,0 -2.65e-4,0 0,0 0,0 0,2.7e-4 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 h -2.64e-4 l -2.65e-4,2.6e-4 c -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 h -2.65e-4 c 0,2.7e-4 -2.64e-4,2.7e-4 -7.94e-4,2.7e-4 -2.64e-4,2.6e-4 -7.93e-4,2.6e-4 -0.0013,7.9e-4 v 0 c -7.93e-4,2.6e-4 -0.0011,2.6e-4 -0.0019,7.9e-4 -2.64e-4,0 -7.93e-4,2.7e-4 -7.93e-4,2.7e-4 -0.420511,0.17286 -17.842336,7.32825 -21.842941,7.3286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1259",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1261",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.635811,281.34183 c -0.845431,-0.86956 -1.447235,-1.92401 -1.777259,-3.0565 5.735532,-5.1314 17.678647,-20.60392 17.959457,-20.96833 2.65e-4,0 2.65e-4,-2.7e-4 7.94e-4,-8e-4 l 2.64e-4,-2.6e-4 c 2.65e-4,-2.7e-4 2.65e-4,-2.7e-4 7.94e-4,-8e-4 v 0 c 0,-2.6e-4 2.65e-4,-2.6e-4 2.65e-4,-7.9e-4 0,-2.7e-4 2.64e-4,-2.7e-4 2.64e-4,-7.9e-4 2.65e-4,-2.7e-4 7.94e-4,-8e-4 0.0011,-10e-4 0,0 0,-2.7e-4 2.64e-4,-2.7e-4 v -2.6e-4 c 2.65e-4,-2.7e-4 7.94e-4,-2.7e-4 7.94e-4,-8e-4 v 0 c 2.65e-4,-2.6e-4 2.65e-4,-2.6e-4 2.65e-4,-2.6e-4 v -2.6e-4 0 2.6e-4 c -2.65e-4,2.6e-4 -0.0011,10e-4 -0.0024,0.003 0,2.7e-4 0,2.7e-4 -2.64e-4,7.9e-4 -0.226484,0.29669 -13.761472,18.03185 -16.184315,24.02731 m 16.187138,-24.03119 v 0 c 2.64e-4,0 2.64e-4,0 2.64e-4,0 v 0 h -2.64e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1263",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 21.858552,278.28533 c -0.257986,-0.88579 -0.349602,-1.81927 -0.261302,-2.74948 1.015612,-0.0963 2.027237,-0.40721 2.96859,-0.95042 3.464665,-2.00064 14.975944,-16.91001 15.252169,-17.26843 -0.28081,0.36441 -12.223925,15.83693 -17.959457,20.96833 m 17.960164,-20.96904 2.64e-4,-2.7e-4 -2.64e-4,2.7e-4 m 0.0011,-10e-4 v 0 0 m 2.64e-4,-7.9e-4 c 0,-2.7e-4 2.65e-4,-2.7e-4 2.65e-4,-8e-4 0,2.7e-4 -2.65e-4,2.7e-4 -2.65e-4,8e-4 m 0.0013,-0.002 c 0,0 0,-2.6e-4 2.65e-4,-2.6e-4 -2.65e-4,0 -2.65e-4,2.6e-4 -2.65e-4,2.6e-4 m 2.65e-4,-7.9e-4 c 2.65e-4,-2.6e-4 7.94e-4,-2.6e-4 7.94e-4,-7.9e-4 0,2.6e-4 -2.65e-4,2.6e-4 -7.94e-4,7.9e-4 m 7.94e-4,-7.9e-4 c 2.64e-4,-2.7e-4 2.64e-4,-2.7e-4 2.64e-4,-2.7e-4 0,0 0,0 -2.64e-4,2.7e-4 m 2.64e-4,-8e-4 c 2.65e-4,0 2.65e-4,0 2.65e-4,0 0,0 0,0 -2.65e-4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1265",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.8904,283.56652 c -0.596017,0 -1.195457,-0.0727 -1.785654,-0.222 0.248179,-0.3175 0.513856,-0.69494 0.794702,-1.1242 0.294887,0.48574 0.646289,0.93832 1.047716,1.34578 -0.01886,5.3e-4 -0.03789,5.3e-4 -0.05676,5.3e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1267",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 27.104746,283.34452 c -0.641491,-0.16193 -1.271517,-0.4141 -1.872897,-0.76123 -0.601239,-0.34713 -1.134957,-0.76701 -1.596038,-1.24146 2.422843,-5.99546 15.957831,-23.73062 16.184315,-24.0273 -0.208844,0.2734 -11.696064,15.32854 -12.734536,19.20444 -0.539115,2.01122 -0.187149,4.05126 0.813858,5.70135 -0.280846,0.42926 -0.546523,0.8067 -0.794702,1.1242 m 12.715734,-26.0307 c 0.0013,-0.001 0.0021,-0.002 0.0024,-0.003 -2.65e-4,2.6e-4 -0.0011,0.001 -0.0024,0.003 m 0.0024,-0.003 v 0 0 h 2.64e-4 v 0 0 0 h -2.64e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1269",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.819067,257.31347 c 2.65e-4,0 7.94e-4,-2.7e-4 0.0011,-2.7e-4 -2.65e-4,0 -7.94e-4,2.7e-4 -0.0011,2.7e-4 m 0.0021,-10e-4 c 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,0 0,0 0,2.6e-4 m 7.94e-4,-7.9e-4 v 0 0 m 2.64e-4,-2.7e-4 v 0 0 m 7.94e-4,-7.9e-4 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1271",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.818009,257.317 c 2.65e-4,0 2.65e-4,-2.7e-4 7.94e-4,-8e-4 -2.65e-4,2.7e-4 -2.65e-4,8e-4 -7.94e-4,8e-4 m 0.0011,-0.001 c 0,-2.7e-4 2.65e-4,-2.7e-4 7.94e-4,-8e-4 -2.64e-4,2.7e-4 -2.64e-4,2.7e-4 -7.94e-4,8e-4 m 7.94e-4,-8e-4 c 0,-2.6e-4 2.65e-4,-2.6e-4 2.65e-4,-7.9e-4 0,2.6e-4 -2.65e-4,2.6e-4 -2.65e-4,7.9e-4 m 7.94e-4,-10e-4 c 2.65e-4,-2.6e-4 7.94e-4,-7.9e-4 0.0011,-0.001 -2.64e-4,2.7e-4 -7.93e-4,8e-4 -0.0011,0.001 m 0.0013,-0.001 v -2.7e-4 2.7e-4 m 7.94e-4,-10e-4 v 0 0 m 2.64e-4,-2.7e-4 c 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 v 0 0 2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1273",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 21.59725,275.53585 c 0.09648,-1.01561 0.407493,-2.02706 0.951124,-2.96827 2.005612,-3.47416 16.993058,-15.03962 17.270693,-15.25411 2.65e-4,0 7.94e-4,-2.7e-4 0.0011,-2.7e-4 2.64e-4,-2.6e-4 7.94e-4,-7.9e-4 0.0011,-7.9e-4 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 2.65e-4,0 2.65e-4,-2.7e-4 7.94e-4,-2.7e-4 v 0 c 0,0 0,-2.6e-4 2.64e-4,-2.6e-4 v 0 c 2.65e-4,-2.7e-4 2.65e-4,-2.7e-4 7.94e-4,-8e-4 v 0 h 2.65e-4 v 0 c 0,0 0,0 -2.65e-4,0 0,0 0,0 0,2.7e-4 0,0 0,0 -2.64e-4,2.6e-4 v 0 c 0,2.7e-4 -2.65e-4,2.7e-4 -7.94e-4,8e-4 v 2.6e-4 c -2.65e-4,0 -2.65e-4,2.6e-4 -2.65e-4,2.6e-4 -2.64e-4,2.7e-4 -7.93e-4,8e-4 -0.0011,10e-4 0,2.7e-4 -2.65e-4,2.7e-4 -2.65e-4,8e-4 0,2.6e-4 -2.64e-4,2.6e-4 -2.64e-4,7.9e-4 v 0 c -2.65e-4,2.7e-4 -7.94e-4,2.7e-4 -7.94e-4,7.9e-4 l -2.65e-4,2.7e-4 c -2.64e-4,2.6e-4 -2.64e-4,7.9e-4 -7.93e-4,7.9e-4 -0.276225,0.35843 -11.787504,15.2678 -15.25217,17.26844 -0.941352,0.54321 -1.952978,0.85411 -2.96859,0.95042"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1275",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822949,257.31065 v 0 0 m 2.64e-4,0 v 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1277",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 30.407203,284.71262 c -0.539644,-0.32176 -1.028557,-0.70831 -1.460039,-1.14652 0.572452,-0.005 1.14074,-0.0758 1.693333,-0.21125 -0.104987,0.50229 -0.184116,0.95776 -0.233294,1.35777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1279",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.276224,285.74905 c 0.157692,-0.37109 0.316442,-0.80395 0.476602,-1.29149 0.410633,0.39304 0.866775,0.73904 1.359958,1.0287 -0.592312,0.16373 -1.208617,0.25369 -1.83656,0.26279"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1281",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.171801,285.74976 c -0.627944,0 -1.266119,-0.081 -1.901825,-0.2515 -0.670629,-0.17956 -1.294694,-0.4469 -1.862773,-0.78564 0.04918,-0.40001 0.128307,-0.85548 0.233294,-1.35777 0.895702,-0.21953 1.750129,-0.60688 2.51107,-1.14804 0.388409,0.84984 0.934863,1.61258 1.601259,2.25075 -0.16016,0.48754 -0.31891,0.9204 -0.476602,1.29149 -0.03492,5.3e-4 -0.0695,7.9e-4 -0.104423,7.9e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1283",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.820126,257.31453 c 2.64e-4,-2.7e-4 2.64e-4,-2.7e-4 2.64e-4,-8e-4 0,2.7e-4 0,2.7e-4 -2.64e-4,8e-4 m 0.0028,-0.004 v -2.7e-4 2.7e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1285",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.947164,283.5661 c -0.401427,-0.40746 -0.752829,-0.86004 -1.047716,-1.34578 4.259403,-6.51411 11.914328,-24.8871 11.923853,-24.90967 v 0 0 c 0,0 0,0 -2.65e-4,0 v 0 c 0,2.6e-4 0,2.6e-4 0,2.6e-4 v 0 2.6e-4 0 c -2.64e-4,2.7e-4 -2.64e-4,8e-4 -2.64e-4,10e-4 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 0,2.7e-4 0,2.7e-4 0,8e-4 -2.65e-4,2.6e-4 -2.65e-4,7.9e-4 -7.94e-4,10e-4 0,0 0,2.6e-4 -2.64e-4,7.9e-4 0,2.7e-4 0,2.7e-4 0,2.7e-4 -2.65e-4,2.6e-4 -2.65e-4,2.6e-4 -2.65e-4,7.9e-4 0,0 0,2.7e-4 -2.64e-4,8e-4 v 2.6e-4 c -0.164397,0.39899 -7.602715,18.49935 -9.179984,26.03751 -0.552593,0.13546 -1.120881,0.20669 -1.693333,0.21124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1287",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 27.899448,282.22032 c -1.001007,-1.65009 -1.352973,-3.69013 -0.813858,-5.70135 1.038472,-3.8759 12.525692,-18.93104 12.734536,-19.20444 2.64e-4,-2.7e-4 2.64e-4,-2.7e-4 2.64e-4,-8e-4 0.0013,-0.001 0.0021,-0.002 0.0024,-0.003 v -2.6e-4 h 2.64e-4 v 0 0 c -0.0095,0.0226 -7.66445,18.39556 -11.923852,24.90967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1289",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 30.640497,283.35485 c 1.577269,-7.53815 9.015587,-25.63851 9.179983,-26.0375 -0.161925,0.39335 -7.329664,17.83997 -7.329313,21.84357 0,1.08702 0.236363,2.11847 0.6604,3.04589 -0.760941,0.54116 -1.615368,0.92851 -2.51107,1.14804 M 39.82048,257.317 c 2.65e-4,-2.7e-4 2.65e-4,-8e-4 2.65e-4,-8e-4 0,0 0,2.7e-4 -2.65e-4,8e-4 m 7.94e-4,-0.001 c 0,0 0,0 0,-2.6e-4 v 2.6e-4 m 2.65e-4,-10e-4 c 2.64e-4,-7.9e-4 2.64e-4,-10e-4 7.93e-4,-10e-4 -2.64e-4,2.7e-4 -2.64e-4,7.9e-4 -7.93e-4,10e-4 m 7.93e-4,-0.002 c 0,0 0,0 2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 m 7.94e-4,-10e-4 v 0 0 m 0,-2.7e-4 v 0 0 m 0,-2.6e-4 v 0 0 m 2.65e-4,0 v 0 0 m 0,0 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1291",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.82023,286.2162 c -0.604663,-0.17142 -1.177221,-0.41808 -1.707446,-0.72994 0.551746,-0.1524 1.082675,-0.36833 1.58115,-0.64244 0.02858,0.51262 0.07021,0.97303 0.126296,1.37238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1293",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.825667,286.21581 c 0.05609,-0.39938 0.09772,-0.85866 0.125942,-1.3709 0.498475,0.27341 1.0287,0.48934 1.580092,0.64178 -0.529519,0.31143 -1.101725,0.55809 -1.706034,0.72912"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1295",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822949,286.49306 c -0.694267,0 -1.366308,-0.0966 -2.002719,-0.27686 -0.05609,-0.39935 -0.09772,-0.85976 -0.126296,-1.37238 0.808567,-0.44344 1.533525,-1.03847 2.128663,-1.75852 0.595135,0.7203 1.320445,1.31589 2.129012,1.75961 -0.02822,0.51224 -0.06985,0.97152 -0.125942,1.3709 -0.63641,0.18066 -1.308451,0.27696 -2.002718,0.27725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1297",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 36.112784,285.48626 c -0.493183,-0.28966 -0.949325,-0.63566 -1.359958,-1.0287 2.401358,-7.31269 5.00874,-26.68795 5.069416,-27.1388 0,-2.6e-4 0,-2.6e-4 0,-7.9e-4 0,-10e-4 2.65e-4,-0.002 2.65e-4,-0.003 0,-0.001 2.65e-4,-0.002 2.65e-4,-0.002 v -2.6e-4 0 c 0,-2.7e-4 0,-2.7e-4 0,-2.7e-4 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 v 0 c 0,-2.7e-4 0,-2.7e-4 0,-2.7e-4 2.64e-4,0 2.64e-4,0 2.64e-4,0 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 v 0 0 0 0 c 0,0 -2.64e-4,2.6e-4 -2.64e-4,7.9e-4 v 0 c 0,0 0,0 0,2.7e-4 0,0 0,0 0,2.6e-4 v 0 c 0,2.6e-4 0,2.6e-4 0,2.6e-4 0,2.7e-4 0,2.7e-4 0,2.7e-4 0,2.6e-4 0,2.6e-4 0,7.9e-4 -2.65e-4,2.7e-4 -2.65e-4,8e-4 -2.65e-4,10e-4 0,2.7e-4 0,8e-4 0,10e-4 0,0 0,2.6e-4 0,7.9e-4 l -2.65e-4,2.7e-4 c 0,2.6e-4 0,2.6e-4 0,7.9e-4 0,0 0,2.7e-4 0,8e-4 0,0 0,2.6e-4 0,7.9e-4 -2.64e-4,7.9e-4 -2.64e-4,0.002 -2.64e-4,0.002 0,2.6e-4 0,2.6e-4 -2.65e-4,7.9e-4 0,2.7e-4 0,2.7e-4 0,8e-4 -0.07056,0.5461 -2.553758,19.85613 -2.127604,27.52118 -0.498475,0.27411 -1.029404,0.49004 -1.58115,0.64244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1299",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.752826,284.45756 c -0.666396,-0.63817 -1.21285,-1.40091 -1.601259,-2.25075 0.831499,-0.59119 1.552224,-1.36631 2.095855,-2.30752 2.00025,-3.46495 4.515202,-22.13674 4.57482,-22.58053 -0.06068,0.45085 -2.668058,19.82611 -5.069416,27.1388 m 5.069416,-27.13951 c 0,-0.001 2.65e-4,-0.002 2.65e-4,-0.003 0,0.001 -2.65e-4,0.002 -2.65e-4,0.003 m 7.94e-4,-0.006 v -2.7e-4 2.7e-4 m 0,-2.7e-4 c 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,0 0,0 0,2.6e-4 m 0,-7.9e-4 v 0 0 m 0,-2.6e-4 h 2.65e-4 c 0,0 0,0 -2.65e-4,0 m 2.65e-4,-2.7e-4 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1301",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.693934,284.84382 c -0.426154,-7.66505 2.057048,-26.97508 2.127605,-27.52118 -0.06915,0.53728 -2.458157,19.13678 -1.424872,22.99158 0.280813,1.04976 0.776113,1.98505 1.42593,2.77108 -0.595138,0.72005 -1.320096,1.31508 -2.128663,1.75852 m 2.127605,-27.52188 c 2.64e-4,-2.7e-4 2.64e-4,-2.7e-4 2.64e-4,-8e-4 0,2.7e-4 0,2.7e-4 -2.64e-4,8e-4 m 7.93e-4,-0.003 c 0,-2.6e-4 0,-7.9e-4 0,-7.9e-4 0,2.6e-4 0,2.6e-4 0,7.9e-4 m 0,-10e-4 c 0,-2.7e-4 0,-2.7e-4 0,-8e-4 0,2.7e-4 0,2.7e-4 0,8e-4 m 2.65e-4,-0.001 c 0,-2.7e-4 0,-7.9e-4 0,-7.9e-4 0,0 0,2.6e-4 0,7.9e-4 m 0,-0.002 c 0,-2.7e-4 0,-8e-4 2.65e-4,-10e-4 -2.65e-4,2.6e-4 -2.65e-4,7.9e-4 -2.65e-4,10e-4 m 2.65e-4,-0.002 c 0,0 0,0 0,-2.6e-4 0,2.6e-4 0,2.6e-4 0,2.6e-4 m 0,-7.9e-4 v 0 0 m 0,-2.6e-4 c 0,-2.7e-4 0,-2.7e-4 0,-2.7e-4 0,0 0,0 0,2.7e-4 m 0,-2.7e-4 c 0,-2.6e-4 2.64e-4,-7.9e-4 2.64e-4,-7.9e-4 0,0 -2.64e-4,2.6e-4 -2.64e-4,7.9e-4 m 2.64e-4,-7.9e-4 v 0 0 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1303",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.82048,257.31735 v -2.7e-4 2.7e-4 m 2.65e-4,-10e-4 c 0,-2.7e-4 0,-2.7e-4 2.64e-4,-7.9e-4 -2.64e-4,2.6e-4 -2.64e-4,2.6e-4 -2.64e-4,7.9e-4 m 2.64e-4,-10e-4 c 2.65e-4,-2.6e-4 2.65e-4,-7.9e-4 2.65e-4,-7.9e-4 0,0 0,2.6e-4 -2.65e-4,7.9e-4 m 0.0011,-0.002 c 0,-2.6e-4 0,-2.6e-4 0,-7.9e-4 0,2.6e-4 0,2.6e-4 0,7.9e-4 m 2.64e-4,-7.9e-4 c 0,-2.6e-4 0,-7.9e-4 2.65e-4,-0.001 -2.65e-4,2.7e-4 -2.65e-4,8e-4 -2.65e-4,0.001 m 2.65e-4,-0.001 v -2.6e-4 2.6e-4 m 0,-2.6e-4 c 0,0 0,0 0,-2.7e-4 0,2.7e-4 0,2.7e-4 0,2.7e-4 m 0,-2.7e-4 c 2.65e-4,0 2.65e-4,0 2.65e-4,0 h -2.65e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1305",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822242,257.31876 c 0,-2.6e-4 0,-2.6e-4 0,-7.9e-4 0,2.6e-4 0,2.6e-4 0,7.9e-4 m 2.65e-4,-0.004 c 0,-10e-4 2.65e-4,-0.002 2.65e-4,-0.002 0,7.9e-4 -2.65e-4,10e-4 -2.65e-4,0.002 m 2.65e-4,-0.003 v 0 0 m 0,-2.7e-4 c 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,0 0,0 0,2.6e-4 m 0,-2.6e-4 c 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,0 0,0 0,2.6e-4 m 2.64e-4,-2.6e-4 c 0,-2.7e-4 0,-2.7e-4 0,-2.7e-4 0,0 0,0 0,2.7e-4 m 0,-2.7e-4 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1307",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.151567,282.20681 c -0.424037,-0.92742 -0.6604,-1.95887 -0.6604,-3.04589 -2.64e-4,-4.0036 7.167388,-21.45022 7.329313,-21.84357 v -2.7e-4 c 2.65e-4,-2.6e-4 2.65e-4,-7.9e-4 2.65e-4,-7.9e-4 0,-2.7e-4 0,-2.7e-4 2.64e-4,-7.9e-4 v -2.7e-4 c 2.65e-4,-2.6e-4 2.65e-4,-7.9e-4 2.65e-4,-7.9e-4 2.65e-4,-8e-4 2.65e-4,-10e-4 7.94e-4,-10e-4 0,-2.6e-4 0,-2.6e-4 0,-7.9e-4 0,0 0,0 2.64e-4,0 0,-2.6e-4 0,-7.9e-4 2.65e-4,-0.001 v 0 -2.6e-4 0 c 0,0 0,0 0,-2.7e-4 v 0 h 2.65e-4 v 0 0 0 0 0 c 0,0 0,0 0,2.7e-4 h -2.65e-4 c 0,0 0,0 0,2.6e-4 v 0 c 0,0 0,0 0,2.7e-4 0,0 0,0 0,2.6e-4 v 0 2.7e-4 c 0,7.9e-4 -2.65e-4,10e-4 -2.65e-4,0.002 0,10e-4 -2.64e-4,0.002 -2.64e-4,0.003 0,2.7e-4 0,2.7e-4 0,8e-4 -0.05962,0.44379 -2.574571,19.11558 -4.574821,22.58052 -0.543631,0.94121 -1.264356,1.71634 -2.095854,2.30752"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1309",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 45.369674,285.74947 c -0.628298,-0.009 -1.245307,-0.0991 -1.837973,-0.26278 0.493538,-0.29009 0.950383,-0.63609 1.361371,-1.02983 0.159808,0.48757 0.319262,0.92149 0.476602,1.29261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1311",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 49.238941,284.71223 c -0.786694,-6.40139 -9.226902,-26.94262 -9.412817,-27.39418 v -2.6e-4 c -7.94e-4,-10e-4 -0.0011,-0.002 -0.0013,-0.004 0,-2.6e-4 -2.65e-4,-2.6e-4 -2.65e-4,-7.9e-4 v 0 c 0,0 0,-2.7e-4 -2.64e-4,-2.7e-4 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,-2.7e-4 0,-2.7e-4 -2.65e-4,-8e-4 v 0 -2.6e-4 0 c 0,-2.7e-4 -2.64e-4,-2.7e-4 -2.64e-4,-2.7e-4 v 0 c 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0.01659,0.0402 7.665508,18.3987 11.922831,24.90925 -0.611717,1.00816 -1.466143,1.87109 -2.507192,2.49233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1313",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 45.473039,285.75018 c -0.03457,0 -0.06879,-5.3e-4 -0.103365,-8e-4 -0.15734,-0.37112 -0.316794,-0.80503 -0.476602,-1.29261 1.39347,-1.33449 2.261304,-3.21412 2.261658,-5.29622 0,-4.00085 -7.157156,-21.42631 -7.328606,-21.84258 0.185915,0.45155 8.626123,20.99278 9.412817,27.39418 -0.568325,0.3394 -1.19239,0.60646 -1.863019,0.78602 -0.635706,0.17046 -1.274588,0.25192 -1.902883,0.25192 M 39.826124,257.3177 c -7.94e-4,-10e-4 -0.0011,-0.002 -0.0013,-0.004 2.65e-4,0.001 7.94e-4,0.002 0.0013,0.004 m -0.0019,-0.004 v 0 0 m -2.65e-4,-2.7e-4 c 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,0 0,0 0,2.6e-4 m -2.64e-4,-10e-4 v 0 0 m 0,-2.7e-4 v 0 0 m -2.65e-4,-2.6e-4 v 0 0 m 0,-2.7e-4 c 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 v 0 c 0,0 0,0 0,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1315",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 51.746132,282.2199 c -4.257323,-6.51055 -11.90625,-24.86904 -11.922831,-24.90925 v 0 0 0 l 10.265833,20.63499 c 0.76835,0.76867 1.665113,1.33064 2.620788,1.68659 -0.155223,0.92149 -0.485423,1.79931 -0.96379,2.58767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1317",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.531701,285.48669 c -0.551392,-0.15244 -1.081617,-0.36837 -1.580092,-0.64178 0.42898,-7.7145 -2.088443,-27.22523 -2.127954,-27.53074 v -2.6e-4 c -2.64e-4,-0.001 -2.64e-4,-0.002 -2.64e-4,-0.002 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,-2.7e-4 0,-2.7e-4 0,-2.7e-4 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 v 0 c 0.0028,0.0215 2.640896,19.75167 5.069771,27.14621 -0.410988,0.39374 -0.867833,0.73974 -1.361371,1.02983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1319",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.951609,284.84491 c -0.808567,-0.44372 -1.533877,-1.03931 -2.129012,-1.75961 0.650169,-0.78631 1.14582,-1.72156 1.427337,-2.7715 1.039638,-3.87974 -1.387475,-22.69906 -1.426279,-22.99963 0.03951,0.30551 2.556934,19.81624 2.127954,27.53074 m -2.127954,-27.53109 c -2.64e-4,-0.001 -2.64e-4,-0.002 -2.64e-4,-0.002 0,2.7e-4 0,10e-4 2.64e-4,0.002 m -2.64e-4,-0.002 c 0,-2.7e-4 0,-2.7e-4 0,-2.7e-4 0,0 0,0 0,2.7e-4 m 0,-7.9e-4 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1321",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.826124,257.31805 v -2.6e-4 2.6e-4 m -0.0013,-0.004 c 0,-2.6e-4 -2.65e-4,-2.6e-4 -2.65e-4,-7.9e-4 0,2.7e-4 2.65e-4,2.7e-4 2.65e-4,7.9e-4 m -2.65e-4,-7.9e-4 c 0,0 0,-2.6e-4 -2.64e-4,-2.6e-4 2.64e-4,0 2.64e-4,2.6e-4 2.64e-4,2.6e-4 m -2.64e-4,-7.9e-4 c 0,-2.7e-4 0,-2.7e-4 -2.65e-4,-8e-4 2.65e-4,2.7e-4 2.65e-4,2.7e-4 2.65e-4,8e-4 m -2.65e-4,-8e-4 v -2.6e-4 2.6e-4 m 0,-2.6e-4 c 0,-2.7e-4 -2.64e-4,-2.7e-4 -2.64e-4,-2.7e-4 0,0 2.64e-4,0 2.64e-4,2.7e-4 m -2.64e-4,-2.7e-4 c 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,0 0,0 0,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1323",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.893072,284.45686 c -2.428875,-7.39454 -5.066948,-27.1247 -5.069771,-27.14621 v 0 0 0 c 0,0 0,0 0,2.6e-4 0,0 0,0 0,2.6e-4 v 0 c 0,0 2.64e-4,0 2.64e-4,2.7e-4 v 0 2.6e-4 0 c 2.65e-4,2.7e-4 2.65e-4,2.7e-4 2.65e-4,8e-4 0,0 0,0 0,2.6e-4 2.65e-4,0 2.65e-4,2.7e-4 2.65e-4,2.7e-4 v 0 c 0,2.6e-4 2.64e-4,2.6e-4 2.64e-4,7.9e-4 2.65e-4,10e-4 7.94e-4,0.002 0.0013,0.004 v 2.6e-4 c 0.17145,0.41628 7.328606,17.84174 7.328606,21.84259 -2.64e-4,2.0821 -0.868187,3.96173 -2.261658,5.29622"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1325",
    style: {
      fill: "#152331",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1327",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.821539,257.32264 c 0,-2.7e-4 0,-2.7e-4 0,-7.9e-4 0,2.6e-4 0,2.6e-4 0,7.9e-4 m 2.64e-4,-10e-4 c 0,-8e-4 0,-0.002 2.65e-4,-0.002 -2.65e-4,8e-4 -2.65e-4,0.001 -2.65e-4,0.002 m 2.65e-4,-0.003 c 0,-2.6e-4 0,-7.9e-4 0,-7.9e-4 0,2.6e-4 0,2.6e-4 0,7.9e-4 m 0,-0.001 2.64e-4,-2.7e-4 -2.64e-4,2.7e-4 m 2.64e-4,-10e-4 c 0,-2.6e-4 0,-7.9e-4 0,-0.001 0,2.7e-4 0,8e-4 0,0.001 m 2.65e-4,-0.002 c 0,-2.6e-4 0,-2.6e-4 0,-7.9e-4 0,2.6e-4 0,2.6e-4 0,7.9e-4 m 0,-10e-4 c 0,0 0,0 0,-2.6e-4 0,2.6e-4 0,2.6e-4 0,2.6e-4 m 0,-2.6e-4 c 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,0 0,0 0,2.6e-4 m 0,-7.9e-4 v 0 0 m 2.65e-4,-8e-4 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1329",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822597,283.0853 c -0.649817,-0.78603 -1.145117,-1.72132 -1.42593,-2.77108 -1.033285,-3.8548 1.355725,-22.4543 1.424872,-22.99158 0,-2.7e-4 0,-2.7e-4 0,-7.9e-4 2.64e-4,-2.7e-4 2.64e-4,-2.7e-4 2.64e-4,-8e-4 0,-0.001 0,-0.002 2.65e-4,-0.002 0,-2.6e-4 0,-2.6e-4 0,-7.9e-4 0,-2.7e-4 0,-2.7e-4 0,-8e-4 0,-2.6e-4 0,-2.6e-4 0,-7.9e-4 l 2.64e-4,-2.7e-4 c 0,-2.6e-4 0,-7.9e-4 0,-7.9e-4 0,-2.6e-4 0,-7.9e-4 0,-10e-4 0,-2.6e-4 0,-7.9e-4 2.65e-4,-0.001 0,-2.6e-4 0,-2.6e-4 0,-7.9e-4 0,0 0,0 0,-2.6e-4 0,0 0,0 0,-2.7e-4 v 0 c 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,-2.7e-4 0,-2.7e-4 0,-2.7e-4 v 0 c 0,-2.6e-4 2.65e-4,-7.9e-4 2.65e-4,-7.9e-4 v 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 c 0,0 0,0 0,2.6e-4 0,0 0,0 0,2.7e-4 0,0 0,0 0,2.6e-4 0,2.7e-4 0,0.001 2.64e-4,0.002 v 2.6e-4 c 0.0388,0.30057 2.465917,19.11989 1.426279,22.99963 -0.281517,1.04994 -0.777169,1.98519 -1.427337,2.7715"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1331",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "M 55.433366,280.09166 C 51.954976,273.21069 40.063191,257.62497 39.82683,257.31523 h -2.64e-4 c 0,-2.6e-4 -2.65e-4,-7.9e-4 -2.65e-4,-7.9e-4 0,-2.7e-4 -2.64e-4,-2.7e-4 -2.64e-4,-2.7e-4 -0.0013,-0.002 -0.0024,-0.003 -0.0024,-0.004 v 0 c 0,0 0,0 0,2.7e-4 2.65e-4,0 2.65e-4,2.6e-4 7.94e-4,10e-4 7.94e-4,2.6e-4 0.0013,10e-4 0.0021,0.002 0.229658,0.29809 13.854993,17.95815 19.01966,21.85137 -1.05904,0.59157 -2.233083,0.90001 -3.412419,0.92576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1333",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 55.273203,280.09332 c -0.869244,0 -1.738136,-0.15378 -2.563281,-0.46109 0.170037,-1.00569 0.131233,-2.06336 -0.149931,-3.11326 -1.037167,-3.87202 -12.502444,-18.90141 -12.733161,-19.20374 0.236361,0.30974 12.128146,15.89546 15.606536,22.77643 -0.05327,0.001 -0.106892,0.002 -0.160163,0.002 m -15.446727,-22.7785 c 0,-2.7e-4 -2.65e-4,-7.9e-4 -2.65e-4,-7.9e-4 0,0 2.65e-4,2.6e-4 2.65e-4,7.9e-4 m -7.94e-4,-10e-4 c -0.0013,-0.002 -0.0024,-0.004 -0.0024,-0.004 v 0 c 0,2.7e-4 0.0011,10e-4 0.0024,0.004"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1335",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 61.678236,276.33376 c -0.24271,-0.32166 -0.538692,-0.6762 -0.880533,-1.05861 0.545748,-0.15918 1.073856,-0.38146 1.571625,-0.66393 -0.154517,0.59517 -0.384879,1.17436 -0.691092,1.72254"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1337",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.845784,279.1659 c -5.164667,-3.89322 -18.790002,-21.55328 -19.01966,-21.85137 0.211667,0.2741 11.77925,15.26543 15.25411,17.27132 1.154642,0.66668 2.414765,0.98351 3.658658,0.98351 0.698852,0 1.392415,-0.10019 2.058811,-0.29421 0.341841,0.38241 0.637823,0.73695 0.880533,1.05861 -0.322437,0.57754 -0.729544,1.12116 -1.220258,1.61188 -0.491067,0.49114 -1.034696,0.89778 -1.612194,1.22026 M 39.824007,257.31206 c -2.64e-4,-8e-4 -2.64e-4,-10e-4 -7.94e-4,-10e-4 2.65e-4,0 2.65e-4,2.6e-4 7.94e-4,10e-4 m -7.94e-4,-10e-4 v 0 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1339",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.82683,257.31523 h -2.64e-4 2.64e-4 m -7.93e-4,-7.9e-4 c 0,-2.7e-4 -2.65e-4,-2.7e-4 -2.65e-4,-2.7e-4 0,0 2.65e-4,0 2.65e-4,2.7e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1341",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 52.709922,279.63223 c -0.955675,-0.35595 -1.852438,-0.91792 -2.620788,-1.68659 L 39.823301,257.31065 v 0 0 c 0,0 0.0011,10e-4 0.0024,0.004 0,0 2.65e-4,0 2.65e-4,2.7e-4 0,0 2.64e-4,2.6e-4 2.64e-4,7.9e-4 h 2.65e-4 c 0.230716,0.30233 11.695993,15.33173 12.73316,19.20374 0.281165,1.04991 0.319969,2.10757 0.149931,3.11327"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1343",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1345",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 62.369328,274.61122 c 0.143581,-0.55386 0.221898,-1.12148 0.234246,-1.6902 0.4572,0.23139 0.877358,0.42584 1.250595,0.57687 -0.450143,0.4378 -0.950383,0.81029 -1.484841,1.11333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1347",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 65.856891,270.02895 c -0.3175,-0.24803 -0.694974,-0.5136 -1.124305,-0.79441 0.48613,-0.29493 0.93839,-0.64629 1.345848,-1.04776 0.0049,0.61454 -0.06773,1.23363 -0.221543,1.84217"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1349",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 63.854169,273.49789 c -0.373237,-0.15103 -0.793395,-0.34548 -1.250595,-0.57687 0.01976,-0.92216 -0.132998,-1.8471 -0.458965,-2.72231 0.921457,-0.15571 1.799167,-0.48588 2.587977,-0.96417 0.429331,0.28081 0.806805,0.54638 1.124305,0.79441 -0.161925,0.64174 -0.414163,1.27138 -0.761649,1.8729 -0.347133,0.60152 -0.766585,1.13496 -1.241073,1.59604"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1351",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.826124,257.31453 c -7.94e-4,-10e-4 -0.0013,-0.002 -0.0021,-0.002 7.94e-4,2.6e-4 0.0013,0.001 0.0021,0.002 m -0.0028,-0.004 c 0,-2.7e-4 0,-2.7e-4 0,-2.7e-4 0,0 0,0 0,2.7e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1353",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 60.797703,275.27515 c -5.186892,-5.79798 -20.940181,-17.93805 -20.974402,-17.9645 0.03457,0.0264 15.837606,12.10094 22.780273,15.61037 -0.01236,0.56872 -0.09067,1.13634 -0.234246,1.6902 -0.497769,0.28247 -1.025877,0.50475 -1.571625,0.66393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1355",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 58.738892,275.56936 c -1.243893,0 -2.504016,-0.31683 -3.658658,-0.98351 -3.47486,-2.00589 -15.042443,-16.99722 -15.25411,-17.27132 -7.94e-4,-10e-4 -0.0013,-0.002 -0.0021,-0.002 -2.64e-4,-8e-4 -2.64e-4,-10e-4 -7.94e-4,-10e-4 0,-2.7e-4 0,-2.7e-4 0,-2.7e-4 v 0 0 0 0 c 0.03422,0.0265 15.787511,12.16653 20.974402,17.9645 -0.666395,0.19403 -1.359958,0.29422 -2.05881,0.29422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1357",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 62.603574,272.92102 c -6.942667,-3.50943 -22.7457,-15.58392 -22.780273,-15.61037 v 0 c 0.02222,0.0169 15.299618,11.6907 19.208043,12.73732 0.635707,0.17046 1.274234,0.25192 1.902532,0.25192 0.409223,0 0.81421,-0.0346 1.210733,-0.10118 0.325967,0.87521 0.478719,1.80015 0.458965,2.72231"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1359",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 66.078434,268.18678 c -0.0042,-0.57255 -0.07549,-1.14088 -0.21096,-1.69368 0.502002,0.10513 0.957792,0.1845 1.357842,0.23354 -0.322088,0.53975 -0.70838,1.0287 -1.146882,1.46014"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1361",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 68.261776,262.85737 c -0.371123,-0.15734 -0.804334,-0.31644 -1.291873,-0.4766 0.392996,-0.41028 0.739071,-0.86678 1.029054,-1.35996 0.163687,0.59231 0.253646,1.20897 0.262819,1.83656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1363",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 67.225316,266.72664 c -0.40005,-0.049 -0.85584,-0.12841 -1.357842,-0.23354 -0.21943,-0.8957 -0.60678,-1.74978 -1.14794,-2.51107 0.849842,-0.38841 1.612194,-0.93451 2.250369,-1.60126 0.487539,0.16016 0.92075,0.31926 1.291873,0.4766 0.0095,0.66181 -0.07126,1.33597 -0.250825,2.0066 -0.179565,0.67063 -0.446969,1.29469 -0.785635,1.86267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1365",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 64.732586,269.23454 c -6.457244,-4.22311 -24.569206,-11.78208 -24.904697,-11.92213 -2.65e-4,0 -7.94e-4,0 -7.94e-4,-2.6e-4 -2.65e-4,0 -7.94e-4,0 -0.0011,0 0,-2.7e-4 -2.65e-4,-2.7e-4 -7.94e-4,-2.7e-4 0,-2.6e-4 -2.65e-4,-2.6e-4 -2.65e-4,-2.6e-4 -2.64e-4,0 -7.93e-4,-2.7e-4 -0.0011,-2.7e-4 -2.65e-4,-2.6e-4 -7.94e-4,-2.6e-4 -7.94e-4,-2.6e-4 0,0 0,0 2.65e-4,0 0,0 0,0 0,2.6e-4 0,0 0,0 2.64e-4,0 v 0 h 2.65e-4 c 0,0 0,0 2.65e-4,2.7e-4 v 0 c 2.64e-4,0 2.64e-4,0 2.64e-4,0 2.65e-4,0 2.65e-4,2.6e-4 7.94e-4,2.6e-4 v 0 c 2.64e-4,0 2.64e-4,0 2.64e-4,0 2.65e-4,2.7e-4 2.65e-4,2.7e-4 2.65e-4,2.7e-4 0.287515,0.11818 18.478852,7.59918 26.040998,9.18104 0.135467,0.5528 0.206727,1.12113 0.21096,1.69368 -0.407458,0.40147 -0.859718,0.75283 -1.345848,1.04775"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1367",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 62.144609,270.19871 c -0.355952,-0.95641 -0.918281,-1.85318 -1.686631,-2.62188 -2.836334,-2.83633 -20.299889,-10.12648 -20.630089,-10.26442 0.335491,0.14005 18.447453,7.69902 24.904697,11.92213 -0.78881,0.47829 -1.66652,0.80846 -2.587977,0.96417 M 39.827182,257.31206 c -2.64e-4,0 -7.94e-4,0 -0.0011,0 2.64e-4,0 7.94e-4,0 0.0011,0 m -0.0019,-2.7e-4 c 0,-2.6e-4 -2.64e-4,-2.6e-4 -2.64e-4,-2.6e-4 0,0 2.64e-4,0 2.64e-4,2.6e-4 m -0.0013,-7.9e-4 c -2.64e-4,-2.7e-4 -7.94e-4,-2.7e-4 -7.94e-4,-2.7e-4 v 0 0 c 0,0 2.65e-4,0 7.94e-4,2.7e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1369",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 65.867474,266.4931 c -7.562146,-1.58186 -25.753483,-9.06286 -26.040998,-9.18104 0.282575,0.11606 17.8308,7.33072 21.847175,7.33037 2.64e-4,0 2.64e-4,0 7.94e-4,0 1.086553,0 2.117725,-0.23637 3.045176,-0.6604 0.541161,0.76129 0.928511,1.61537 1.14794,2.51107 m -26.04135,-9.1814 c 0,0 0,0 -2.64e-4,0 2.64e-4,0 2.64e-4,0 2.64e-4,0 m -2.64e-4,0 c -2.65e-4,0 -2.65e-4,-2.6e-4 -7.94e-4,-2.6e-4 2.64e-4,0 2.64e-4,2.6e-4 7.94e-4,2.6e-4 m -0.0011,-2.6e-4 v 0 0 m -2.64e-4,-2.7e-4 h -2.65e-4 2.65e-4 m -2.65e-4,0 c -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 0,0 0,0 2.64e-4,0 m -2.64e-4,-2.6e-4 c -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 v 0 c 0,0 0,0 2.65e-4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1371",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1373",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.827889,257.31241 c -2.65e-4,0 -7.94e-4,0 -7.94e-4,-2.6e-4 0,2.6e-4 2.64e-4,2.6e-4 7.94e-4,2.6e-4 m -0.0019,-2.6e-4 c 0,-2.7e-4 -2.65e-4,-2.7e-4 -7.94e-4,-2.7e-4 2.64e-4,0 7.94e-4,0 7.94e-4,2.7e-4 m -0.0011,-8e-4 c -2.64e-4,0 -7.94e-4,-2.6e-4 -0.0011,-2.6e-4 2.64e-4,0 7.94e-4,2.6e-4 0.0011,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1375",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 60.933876,270.29989 c -0.628298,0 -1.266825,-0.0815 -1.902532,-0.25192 -3.908425,-1.04662 -19.185818,-12.72039 -19.208043,-12.73732 v 0 0 0 c 0,0 2.64e-4,0 7.94e-4,2.6e-4 2.64e-4,0 7.93e-4,2.6e-4 0.0011,2.6e-4 0,0 2.64e-4,0 2.64e-4,2.7e-4 2.65e-4,0 7.94e-4,0 7.94e-4,2.6e-4 2.65e-4,0 7.94e-4,0 0.0011,0 0,2.7e-4 2.64e-4,2.7e-4 7.93e-4,2.7e-4 0.3302,0.13793 17.793756,7.42809 20.630089,10.26442 0.76835,0.7687 1.33068,1.66546 1.686632,2.62188 -0.396523,0.0666 -0.80151,0.10118 -1.210734,0.10118"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1377",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 67.998957,261.02081 c -0.1524,-0.55175 -0.368654,-1.08232 -0.642408,-1.58115 0.512233,-0.0286 0.97296,-0.0699 1.371952,-0.12594 -0.171098,0.60466 -0.418042,1.17722 -0.729544,1.70709"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1379",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c 0,0 0,0 2.64e-4,0 0,0 2.65e-4,0 7.94e-4,-2.7e-4 v 0 c 7.94e-4,0 0.0019,0 0.0032,-2.6e-4 2.65e-4,0 2.65e-4,0 7.94e-4,0 2.64e-4,0 0.0011,0 0.0019,-2.7e-4 h 2.65e-4 c 2.64e-4,0 7.93e-4,0 0.0011,0 0.0011,-2.6e-4 0.0019,-2.6e-4 0.0028,-2.6e-4 v 0 c 0.525285,-0.0706 19.837752,-2.67124 27.135312,-5.06836 0.815623,0.85196 1.428044,1.90041 1.75895,3.06705 -0.87136,-0.12242 -2.031294,-0.17498 -3.389842,-0.17498 -8.627885,0 -25.185862,2.13501 -25.51077,2.17699 0,0 0,0 -2.65e-4,0 0,0 0,0 -2.64e-4,0 0,0 0,0 -2.65e-4,0 0,2.7e-4 -2.64e-4,2.7e-4 -2.64e-4,2.7e-4 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -0.0011,0 -0.0021,2.6e-4 -0.0024,2.6e-4 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1381",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 67.356549,259.43966 c -0.928513,-1.69157 -2.519188,-3.0166 -4.530021,-3.55565 -0.683684,-0.18309 -1.829859,-0.25858 -3.258254,-0.25858 -6.667852,0 -19.455342,1.64782 -19.740385,1.68451 0.324908,-0.042 16.882885,-2.17699 25.51077,-2.17699 1.358548,0 2.518482,0.0526 3.389842,0.17498 0.180268,0.63676 0.276931,1.30845 0.276931,2.00307 0,0.69426 -0.09666,1.36631 -0.276931,2.00272 -0.398992,0.0561 -0.859719,0.0974 -1.371952,0.12594 m -27.532894,-2.12901 c 2.65e-4,0 0.0013,-2.7e-4 0.0024,-2.7e-4 -0.0011,0 -0.0021,2.7e-4 -0.0024,2.7e-4 m 0.0028,-2.7e-4 c 0,0 2.65e-4,0 2.65e-4,-2.6e-4 0,2.6e-4 -2.65e-4,2.6e-4 -2.65e-4,2.6e-4 m 7.94e-4,-2.6e-4 c 2.65e-4,0 2.65e-4,0 2.65e-4,0 0,0 0,0 -2.65e-4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1383",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c 0,0 0,0 2.64e-4,0 -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 v 0 m 0.0011,-2.7e-4 v 0 0 m 0.0032,-2.6e-4 c 2.65e-4,0 2.65e-4,0 7.94e-4,0 -2.65e-4,0 -2.65e-4,0 -7.94e-4,0 m 0.0024,-2.7e-4 h 2.65e-4 -2.65e-4 m 0.0013,0 c 0.0011,-2.6e-4 0.0019,-2.6e-4 0.0028,-2.6e-4 -0.0011,0 -0.0019,0 -0.0028,2.6e-4 m 0.0028,-2.6e-4 c 0.516819,-0.0695 19.120554,-2.5774 22.578129,-4.57447 0.94121,-0.54328 1.716265,-1.26365 2.307519,-2.0948 0.849489,0.38876 1.611489,0.93486 2.249664,1.60091 -7.29756,2.39712 -26.610026,4.9978 -27.135312,5.06836"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1385",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 66.969903,262.38077 c -7.300029,-2.39748 -26.620962,-4.99957 -27.136371,-5.06871 -7.94e-4,0 -0.0013,-2.7e-4 -0.0024,-2.7e-4 0,0 0,0 -2.65e-4,0 -7.93e-4,0 -0.0011,-2.6e-4 -0.0019,-2.6e-4 -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 -7.94e-4,0 -0.0013,-2.7e-4 -0.0019,-2.7e-4 h -2.65e-4 -2.65e-4 -2.64e-4 -2.65e-4 c -2.64e-4,0 -7.93e-4,-2.6e-4 -0.0011,-2.6e-4 v 0 c -2.65e-4,0 -7.94e-4,0 -7.94e-4,0 h -2.64e-4 v 0 0 c 0,0 16.802806,2.17805 25.51571,2.17805 0.73519,0 1.412523,-0.0155 2.017538,-0.049 0.273754,0.49883 0.490008,1.02941 0.642408,1.58115 -0.289983,0.49319 -0.636058,0.94968 -1.029054,1.35996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1387",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 64.719534,263.98203 c -0.591256,-0.8315 -1.366308,-1.55223 -2.307518,-2.0955 -3.458988,-1.99743 -22.072249,-4.50674 -22.578484,-4.57447 0.515409,0.0691 19.836342,2.67123 27.136371,5.06871 -0.638175,0.66675 -1.400527,1.21285 -2.250369,1.60126 m -24.88847,-6.67033 c 0,0 0,0 -2.65e-4,0 2.65e-4,0 2.65e-4,0 2.65e-4,0 m -0.0021,-2.6e-4 c -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 0,0 0,0 2.65e-4,0 m -0.0021,-2.7e-4 h -2.64e-4 2.64e-4 m -7.93e-4,0 h -2.65e-4 2.65e-4 m -7.94e-4,0 c -2.65e-4,0 -7.94e-4,-2.6e-4 -0.0011,-2.6e-4 2.65e-4,0 7.94e-4,2.6e-4 0.0011,2.6e-4 m -0.0011,-2.6e-4 c -2.64e-4,0 -7.93e-4,0 -7.93e-4,0 0,0 2.64e-4,0 7.93e-4,0 m -0.0011,0 v 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1389",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 c 0,0 0,0 2.64e-4,0 -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 m 0.0028,-2.7e-4 c 0,0 0,0 2.64e-4,0 -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 m 7.94e-4,-2.6e-4 c 2.64e-4,0 2.64e-4,0 2.64e-4,0 0,0 0,0 -2.64e-4,0 m 7.93e-4,0 c 2.65e-4,0 2.65e-4,0 2.65e-4,0 0,0 0,0 -2.65e-4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1391",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 65.339011,259.4887 c -8.712904,0 -25.51571,-2.17805 -25.51571,-2.17805 v 0 c 0,0 0,0 2.64e-4,0 2.65e-4,0 0.0013,-2.7e-4 0.0024,-2.7e-4 0,0 0,0 2.64e-4,0 0,0 2.65e-4,0 2.65e-4,-2.6e-4 2.64e-4,0 2.64e-4,0 2.64e-4,0 2.65e-4,0 2.65e-4,0 2.65e-4,0 2.65e-4,0 2.65e-4,0 2.65e-4,0 0.285043,-0.0367 13.072533,-1.68452 19.740385,-1.68452 1.428395,0 2.57457,0.0755 3.258254,0.25859 2.010833,0.53904 3.601508,1.86408 4.530021,3.55565 -0.605015,0.0335 -1.282348,0.049 -2.017538,0.049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1393",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "M 39.823301,257.31065 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1395",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.826476,257.31206 c 0,0 0,0 -2.65e-4,-2.7e-4 2.65e-4,2.7e-4 2.65e-4,2.7e-4 2.65e-4,2.7e-4 m -7.94e-4,-2.7e-4 v 0 0 m -7.94e-4,-2.6e-4 c 0,0 0,0 -2.64e-4,0 2.64e-4,0 2.64e-4,0 2.64e-4,0 m -2.64e-4,0 c -2.65e-4,-2.7e-4 -2.65e-4,-2.7e-4 -2.65e-4,-2.7e-4 0,0 0,0 2.65e-4,2.7e-4 m -7.94e-4,-2.7e-4 v 0 0 m -2.65e-4,0 c 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,0 0,0 0,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1397",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "M 39.823301,257.31065 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1399",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.833532,257.31206 c -7.94e-4,0 -0.0013,-2.7e-4 -0.0024,-2.7e-4 0.0011,0 0.0019,2.7e-4 0.0024,2.7e-4 m -0.0028,-2.7e-4 c -7.94e-4,0 -0.0011,-2.6e-4 -0.0019,-2.6e-4 7.94e-4,0 0.0011,2.6e-4 0.0019,2.6e-4 m -0.0021,-2.6e-4 c -7.94e-4,0 -0.0013,-2.7e-4 -0.0019,-2.7e-4 2.65e-4,0 0.0011,2.7e-4 0.0019,2.7e-4 m -0.0021,-2.7e-4 h -2.65e-4 2.65e-4 m -7.94e-4,0 h -2.64e-4 2.64e-4 m -0.0013,-2.6e-4 v 0 0 m -7.94e-4,0 h -2.64e-4 2.64e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1401",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 61.674357,264.64243 c -2.64e-4,0 -2.64e-4,0 -7.94e-4,0 -4.016375,2.6e-4 -21.5646,-7.21431 -21.847175,-7.33037 0,0 0,0 -2.64e-4,-2.7e-4 0,0 0,0 -2.65e-4,0 v 0 c -2.64e-4,0 -2.64e-4,-2.6e-4 -7.93e-4,-2.6e-4 0,0 0,0 -2.65e-4,0 v 0 c -2.65e-4,-2.7e-4 -2.65e-4,-2.7e-4 -2.65e-4,-2.7e-4 h -2.64e-4 v 0 c -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 v 0 0 0 h 2.64e-4 c 0,0 2.65e-4,0 7.94e-4,0 v 0 c 2.65e-4,0 7.94e-4,2.6e-4 0.0011,2.6e-4 h 2.65e-4 2.64e-4 2.65e-4 2.65e-4 c 2.64e-4,0 0.0011,2.7e-4 0.0019,2.7e-4 0,0 0,0 2.64e-4,0 7.94e-4,0 0.0011,2.6e-4 0.0019,2.6e-4 2.65e-4,0 2.65e-4,0 2.65e-4,0 0.0011,0 0.0019,2.7e-4 0.0024,2.7e-4 0.506235,0.0677 19.119496,2.57704 22.578484,4.57447 0.94121,0.54327 1.716262,1.264 2.307518,2.0955 -0.927452,0.42403 -1.958623,0.6604 -3.045177,0.6604"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1403",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 c 2.64e-4,0 2.64e-4,-2.7e-4 7.94e-4,-2.7e-4 v 0 c 2.64e-4,0 2.64e-4,0 2.64e-4,-2.6e-4 v 0 c 2.65e-4,0 2.65e-4,0 2.65e-4,0 2.64e-4,0 2.64e-4,0 7.93e-4,-2.7e-4 0,0 0,0 2.65e-4,0 2.65e-4,0 2.65e-4,-2.6e-4 7.94e-4,-2.6e-4 0.300566,-0.12524 20.927835,-8.7309 26.030766,-12.71658 0.297392,1.1758 0.291394,2.38971 0.01093,3.53554 -7.489471,1.56703 -25.404937,8.91927 -26.028296,9.17539 v 0 c -0.0028,10e-4 -0.0049,0.002 -0.0071,0.003 -2.65e-4,0 -2.65e-4,0 -7.94e-4,0 -7.94e-4,2.6e-4 -0.0013,7.9e-4 -0.0021,10e-4 -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 -2.65e-4,2.7e-4 -7.94e-4,2.7e-4 -0.0011,2.7e-4 0,2.6e-4 0,2.6e-4 -2.65e-4,2.6e-4 h -2.65e-4 c -2.64e-4,2.7e-4 -7.93e-4,2.7e-4 -0.0011,2.7e-4 -2.65e-4,2.6e-4 -7.94e-4,7.9e-4 -0.0011,7.9e-4 -2.65e-4,0 -2.65e-4,0 -7.94e-4,2.7e-4 v 0 c -2.65e-4,0 -7.94e-4,2.6e-4 -0.0011,2.6e-4 v 0 c -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 v 0 l -2.65e-4,2.7e-4 v 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1405",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0 m 0,0 v 0 0 m 2.64e-4,-2.7e-4 v 0 0 m 2.65e-4,0 v 0 0 m 0.0011,-2.6e-4 v 0 0 m 7.94e-4,-2.7e-4 c 2.65e-4,0 7.94e-4,-2.6e-4 0.0011,-7.9e-4 -2.64e-4,2.6e-4 -7.93e-4,7.9e-4 -0.0011,7.9e-4 m 0.0021,-10e-4 h 2.64e-4 -2.64e-4 m 7.93e-4,-2.6e-4 c 2.65e-4,0 7.94e-4,0 0.0011,-2.7e-4 -2.65e-4,2.7e-4 -7.94e-4,2.7e-4 -0.0011,2.7e-4 m 0.0013,-2.7e-4 c 7.94e-4,-2.6e-4 0.0013,-7.9e-4 0.0021,-10e-4 -7.94e-4,2.6e-4 -0.0013,7.9e-4 -0.0021,10e-4 m 0.0028,-10e-4 c 0.0021,-10e-4 0.0042,-0.002 0.0071,-0.003 -0.0028,10e-4 -0.0049,0.002 -0.0071,0.003 m 0.0071,-0.003 c 0.623358,-0.25612 18.538825,-7.60836 26.028295,-9.17539 -0.219427,0.89605 -0.606777,1.75048 -1.148291,2.51177 -0.927804,-0.42439 -1.959679,-0.6611 -3.046588,-0.6611 -3.977216,0 -21.222051,7.07354 -21.833416,7.32472"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1407",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 62.603926,241.70023 c -0.01236,-0.56868 -0.09031,-1.13595 -0.234244,-1.68981 0.53481,0.30339 1.034344,0.67557 1.484842,1.11337 -0.373946,0.15099 -0.792692,0.34502 -1.250598,0.57644"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1409",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0 0 m 0,0 c 2.64e-4,0 2.64e-4,-2.7e-4 7.94e-4,-2.7e-4 -2.65e-4,0 -2.65e-4,2.7e-4 -7.94e-4,2.7e-4 m 7.94e-4,-2.7e-4 c 2.64e-4,0 2.64e-4,-2.6e-4 2.64e-4,-2.6e-4 0,2.6e-4 0,2.6e-4 -2.64e-4,2.6e-4 m 2.64e-4,-2.6e-4 c 2.65e-4,0 2.65e-4,0 2.65e-4,0 0,0 0,0 -2.65e-4,0 m 0.0011,-2.7e-4 c 0,0 0,0 2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 m 0.0011,-2.6e-4 c 0.275521,-0.11501 17.791641,-7.42386 20.631856,-10.26478 1.472494,-1.47214 2.187575,-3.41489 2.145594,-5.34423 0.457906,-0.23142 0.876652,-0.42545 1.250598,-0.57644 0.474485,0.46108 0.893937,0.99484 1.24107,1.59632 0.347134,0.60113 0.599723,1.2312 0.761648,1.87255 -5.102931,3.98568 -25.7302,12.59134 -26.030766,12.71658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1411",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823655,257.31065 c 0,0 2.65e-4,0 7.94e-4,-2.7e-4 -2.65e-4,2.7e-4 -7.94e-4,2.7e-4 -7.94e-4,2.7e-4 m 7.94e-4,-2.7e-4 c 7.94e-4,0 0.0019,0 0.0032,-2.6e-4 -0.0013,2.6e-4 -0.0024,2.6e-4 -0.0032,2.6e-4 m 0.0039,-2.6e-4 c 2.65e-4,0 0.0011,0 0.0019,-2.7e-4 -7.94e-4,2.7e-4 -0.0013,2.7e-4 -0.0019,2.7e-4 m 0.0021,-2.7e-4 c 2.65e-4,0 7.94e-4,0 0.0011,0 -2.64e-4,0 -7.93e-4,0 -0.0011,0 m 0.0039,-2.6e-4 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1413",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 m 0,0 2.64e-4,-2.7e-4 -2.64e-4,2.7e-4 m 2.64e-4,-2.7e-4 c 0,0 0,0 2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 m 2.65e-4,0 c 2.65e-4,0 7.94e-4,-2.6e-4 0.0011,-2.6e-4 -2.64e-4,0 -7.93e-4,2.6e-4 -0.0011,2.6e-4 m 0.0011,-2.6e-4 c 2.65e-4,-2.7e-4 2.65e-4,-2.7e-4 7.94e-4,-2.7e-4 -2.65e-4,0 -2.65e-4,0 -7.94e-4,2.7e-4 m 0.0019,-10e-4 c 2.65e-4,0 7.94e-4,0 0.0011,-2.7e-4 -2.65e-4,2.7e-4 -7.94e-4,2.7e-4 -0.0011,2.7e-4 m 0.0013,-2.7e-4 c 2.65e-4,0 2.65e-4,0 2.65e-4,-2.6e-4 0,2.6e-4 0,2.6e-4 -2.65e-4,2.6e-4 m 0.0013,-7.9e-4 c 0,0 0,0 2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 m 0.0024,-0.001 c 2.65e-4,0 2.65e-4,0 7.94e-4,0 -2.64e-4,0 -2.64e-4,0 -7.94e-4,0 m 0.0078,-0.003 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1415",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0 0 0 l 2.64e-4,-2.7e-4 v 0 c 0,0 0,0 2.65e-4,0 v 0 c 2.65e-4,0 7.94e-4,-2.6e-4 0.0011,-2.6e-4 v 0 c 2.65e-4,-2.7e-4 2.65e-4,-2.7e-4 7.94e-4,-2.7e-4 2.65e-4,0 7.94e-4,-2.6e-4 0.0011,-7.9e-4 2.65e-4,0 7.94e-4,0 0.0011,-2.7e-4 h 2.64e-4 c 2.65e-4,0 2.65e-4,0 2.65e-4,-2.6e-4 2.64e-4,0 7.94e-4,0 0.0011,-2.7e-4 0,0 0,0 2.65e-4,0 7.94e-4,-2.6e-4 0.0013,-7.9e-4 0.0021,-0.001 2.65e-4,0 2.65e-4,0 7.94e-4,0 0.0021,-10e-4 0.0042,-0.002 0.0071,-0.003 v 0 c 0.611364,-0.25118 17.8562,-7.32472 21.833416,-7.32472 1.086909,0 2.118784,0.23671 3.046587,0.6611 -0.591253,0.83115 -1.366308,1.55152 -2.307518,2.0948 -3.457575,1.99707 -22.06131,4.50497 -22.578129,4.57447 v 0 c -0.0011,0 -0.0019,0 -0.0028,2.6e-4 -2.65e-4,0 -7.94e-4,0 -0.0011,0 h -2.65e-4 c -7.94e-4,2.7e-4 -0.0013,2.7e-4 -0.0019,2.7e-4 -2.65e-4,0 -2.65e-4,0 -7.94e-4,0 -0.0013,2.6e-4 -0.0024,2.6e-4 -0.0032,2.6e-4 v 0 c -2.64e-4,2.7e-4 -7.94e-4,2.7e-4 -7.94e-4,2.7e-4 -2.64e-4,0 -2.64e-4,0 -2.64e-4,0 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1417",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "M 39.823301,257.31065 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1419",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1421",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 62.369682,240.01042 c -0.497771,-0.28222 -1.025525,-0.50447 -1.571625,-0.66357 0.341487,-0.38206 0.638175,-0.73695 0.880534,-1.05869 0.30621,0.54822 0.536575,1.12748 0.691091,1.72226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1423",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 57.787451,236.33589 c -0.159102,-0.5461 -0.381352,-1.0735 -0.663575,-1.57127 0.594783,0.15416 1.173691,0.38453 1.72226,0.69074 -0.322085,0.24271 -0.676275,0.53834 -1.058685,0.88053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1425",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 60.798057,239.34685 c -0.66675,-0.19403 -1.359958,-0.29422 -2.059165,-0.29422 -0.229658,0 -0.459668,0.0109 -0.690033,0.0328 0.08855,-0.93027 -0.0032,-1.86372 -0.261408,-2.74955 0.38241,-0.34219 0.7366,-0.63782 1.058685,-0.88053 0.577498,0.32244 1.12113,0.72954 1.612196,1.22061 0.491067,0.49106 0.897819,1.03434 1.220259,1.61219 -0.242359,0.32174 -0.539047,0.67663 -0.880534,1.05869"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1427",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 m 7.94e-4,-2.7e-4 v 0 0 m 2.64e-4,-2.6e-4 v 0 0 m 2.65e-4,0 c 2.64e-4,0 2.64e-4,0 7.93e-4,-2.7e-4 -2.64e-4,2.7e-4 -2.64e-4,2.7e-4 -7.93e-4,2.7e-4 m 0.0011,-2.7e-4 c 2.65e-4,0 2.65e-4,-2.6e-4 7.94e-4,-2.6e-4 -2.65e-4,0 -2.65e-4,2.6e-4 -7.94e-4,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1429",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0 m 0,0 c 0,-2.7e-4 0,-2.7e-4 2.64e-4,-2.7e-4 v 0 l 2.65e-4,-2.6e-4 2.65e-4,-2.7e-4 c 2.64e-4,0 7.93e-4,-2.6e-4 7.93e-4,-2.6e-4 0,-2.7e-4 2.65e-4,-2.7e-4 2.65e-4,-2.7e-4 2.64e-4,-2.6e-4 7.94e-4,-7.9e-4 0.0011,-0.001 2.65e-4,0 2.65e-4,0 7.94e-4,-2.6e-4 2.65e-4,-2.7e-4 7.94e-4,-7.9e-4 0.0013,-0.001 0,0 2.64e-4,0 2.64e-4,-2.6e-4 7.94e-4,-2.7e-4 0.0013,-0.001 0.0021,-0.001 0,-2.6e-4 2.65e-4,-2.6e-4 7.94e-4,-7.9e-4 0,0 2.64e-4,-2.6e-4 7.94e-4,-2.6e-4 0,-2.7e-4 2.64e-4,-2.7e-4 7.93e-4,-8e-4 l 2.65e-4,-2.6e-4 c 0.45861,-0.35384 15.849952,-12.23857 20.964525,-17.95569 0.5461,0.15911 1.073854,0.38136 1.571625,0.66358 0.143933,0.55386 0.221895,1.12113 0.234244,1.68981 -6.938786,3.50766 -22.729119,15.5709 -22.780625,15.61041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1431",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0 0 c 0.05151,-0.0395 15.84184,-12.10275 22.780625,-15.61042 0.04198,1.92934 -0.6731,3.87209 -2.145594,5.34423 -2.840215,2.84092 -20.356335,10.14977 -20.631856,10.26478 -2.65e-4,0 -2.65e-4,2.6e-4 -7.94e-4,2.6e-4 -2.65e-4,0 -2.65e-4,0 -2.65e-4,0 -2.64e-4,2.6e-4 -2.64e-4,2.6e-4 -7.93e-4,2.6e-4 0,0 0,0 -2.65e-4,0 v 0 c 0,0 0,2.7e-4 -2.64e-4,2.7e-4 v 0 c -2.65e-4,0 -2.65e-4,2.6e-4 -7.94e-4,2.6e-4 v 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1433",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0 m 2.64e-4,-2.7e-4 v 0 0 m 2.65e-4,-2.6e-4 2.65e-4,-2.7e-4 -2.65e-4,2.7e-4 m 0.0011,-8e-4 c 0,-2.6e-4 0,-2.6e-4 2.65e-4,-2.6e-4 0,0 -2.65e-4,0 -2.65e-4,2.6e-4 m 0.0013,-0.001 c 2.65e-4,0 2.65e-4,0 7.94e-4,-2.7e-4 -2.65e-4,2.7e-4 -2.65e-4,2.7e-4 -7.94e-4,2.7e-4 m 0.0021,-10e-4 c 0,0 2.64e-4,0 2.64e-4,-2.7e-4 0,2.7e-4 -2.64e-4,2.7e-4 -2.64e-4,2.7e-4 m 0.0024,-0.002 c 0,-2.6e-4 2.65e-4,-2.6e-4 7.94e-4,-7.9e-4 -2.65e-4,2.7e-4 -7.94e-4,2.7e-4 -7.94e-4,7.9e-4 m 0.0013,-10e-4 c 0,-2.7e-4 2.65e-4,-2.7e-4 7.94e-4,-8e-4 -2.65e-4,2.7e-4 -7.94e-4,2.7e-4 -7.94e-4,8e-4 m 0.0011,-0.001 c 0.450144,-0.34714 15.271396,-11.79583 17.264592,-15.24882 0.543629,-0.94121 0.854427,-1.95298 0.950735,-2.96827 0.230365,-0.0219 0.460375,-0.0328 0.690034,-0.0328 0.699206,0 1.392414,0.10019 2.059164,0.29422 -5.114573,5.71711 -20.505914,17.60184 -20.964525,17.95568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1435",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 57.123876,234.76462 c -0.55386,-0.14394 -1.121482,-0.2219 -1.690159,-0.23425 0.231424,-0.45755 0.425802,-0.87735 0.576792,-1.25095 0.437444,0.4505 0.810332,0.95074 1.113367,1.4852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1437",
    style: {
      fill: "#2e5d77",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 -2.7e-4 c 0,-2.6e-4 0,-2.6e-4 2.64e-4,-7.9e-4 v 0 c 0,-2.7e-4 0,-2.7e-4 0,-2.7e-4 0,0 0,-2.6e-4 2.65e-4,-2.6e-4 0,0 0,0 0,-2.7e-4 v -2.6e-4 c 2.65e-4,0 2.65e-4,-2.7e-4 2.65e-4,-2.7e-4 v 0 c 0,-2.6e-4 2.64e-4,-7.9e-4 2.64e-4,-0.001 0,-2.7e-4 2.65e-4,-8e-4 2.65e-4,-10e-4 2.64e-4,-2.7e-4 2.64e-4,-2.7e-4 2.64e-4,-2.7e-4 0,-2.6e-4 2.65e-4,-0.001 7.94e-4,-0.002 0,-2.6e-4 0,-2.6e-4 2.65e-4,-7.9e-4 0.176037,-0.42792 7.603421,-18.50426 9.179279,-26.03641 0.570794,-0.1397 1.158521,-0.21167 1.749777,-0.21167 0.595842,0 1.195565,0.073 1.78576,0.2219 -3.972983,5.08599 -12.538075,25.60249 -12.715168,26.02724 -2.65e-4,0 -2.65e-4,0 -2.65e-4,2.6e-4 0,0 0,2.6e-4 -2.64e-4,7.9e-4 v 2.7e-4 c 0,0 0,2.6e-4 -2.65e-4,2.6e-4 0,2.7e-4 0,8e-4 -2.65e-4,0.001 0,2.7e-4 -2.64e-4,7.9e-4 -2.64e-4,10e-4 0,0 -2.65e-4,2.6e-4 -2.65e-4,7.9e-4 v 2.7e-4 c -2.64e-4,2.6e-4 -2.64e-4,7.9e-4 -2.64e-4,7.9e-4 -2.65e-4,2.7e-4 -2.65e-4,8e-4 -2.65e-4,0.001 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1439",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0 0 m 0,0 v -2.7e-4 2.7e-4 m 2.64e-4,-0.001 v 0 0 m 0,-2.7e-4 c 0,0 0,-2.6e-4 2.65e-4,-2.6e-4 -2.65e-4,0 -2.65e-4,2.6e-4 -2.65e-4,2.6e-4 m 2.65e-4,-7.9e-4 v -2.7e-4 2.7e-4 m 2.65e-4,-8e-4 v 0 0 m 2.64e-4,-0.001 c 0,-2.7e-4 2.65e-4,-8e-4 2.65e-4,-10e-4 0,2.6e-4 -2.65e-4,7.9e-4 -2.65e-4,10e-4 m 7.94e-4,-10e-4 c 0,-2.6e-4 2.64e-4,-10e-4 7.94e-4,-0.002 -2.65e-4,8e-4 -7.94e-4,0.001 -7.94e-4,0.002 m 0.0011,-0.002 c 0.172863,-0.42051 7.328607,-17.84244 7.328607,-21.84294 0,-1.08656 -0.236361,-2.11772 -0.6604,-3.04553 0.761293,-0.54151 1.615016,-0.92851 2.511073,-1.14794 -1.575859,7.53216 -9.003242,25.60849 -9.17928,26.03641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1441",
    style: {
      fill: "#1e3e56",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0 0 m 0,0 c 0,-2.7e-4 0,-8e-4 2.64e-4,-0.001 -2.64e-4,2.6e-4 -2.64e-4,7.9e-4 -2.64e-4,0.001 m 7.94e-4,-0.002 v -2.6e-4 2.6e-4 m 2.64e-4,-10e-4 c 0,-2.6e-4 2.65e-4,-7.9e-4 2.65e-4,-0.001 0,2.6e-4 -2.65e-4,7.9e-4 -2.65e-4,0.001 m 7.94e-4,-0.002 c 2.64e-4,0 2.64e-4,-2.7e-4 2.64e-4,-2.7e-4 0,0 0,2.7e-4 -2.64e-4,2.7e-4 m 2.64e-4,-8e-4 c 2.65e-4,-2.6e-4 2.65e-4,-7.9e-4 2.65e-4,-7.9e-4 0,0 0,2.7e-4 -2.65e-4,7.9e-4 m 7.94e-4,-10e-4 c 0.177094,-0.42475 8.742185,-20.94125 12.715169,-26.02724 0.641704,0.16192 1.271765,0.41451 1.87325,0.76164 0.601488,0.34714 1.134885,0.76659 1.595966,1.24108 -0.150989,0.37359 -0.345368,0.79339 -0.576791,1.25095 -0.05292,-0.001 -0.10654,-0.002 -0.159457,-0.002 -1.876422,0 -3.753202,0.71579 -5.185127,2.14736 -2.830774,2.83088 -10.099407,20.23552 -10.263097,20.62816"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1443",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0 0 m 0,0 c 0,0 0,0 0,-2.7e-4 0,2.7e-4 0,2.7e-4 0,2.7e-4 m 0,-2.7e-4 v 0 0 m 0,-2.6e-4 v 0 0 m 0,-2.7e-4 c 0,0 0,0 0,-2.6e-4 0,2.6e-4 0,2.6e-4 0,2.6e-4 m 0,-10e-4 c 2.64e-4,-2.6e-4 2.64e-4,-2.6e-4 2.64e-4,-2.6e-4 0,0 0,0 -2.64e-4,2.6e-4 m 2.64e-4,-0.001 v 0 0 m 0,-7.9e-4 c 0,-2.6e-4 0,-7.9e-4 2.65e-4,-10e-4 -2.65e-4,7.9e-4 -2.65e-4,10e-4 -2.65e-4,10e-4 m 2.65e-4,-0.002 c 0,0 0,0 0,-2.6e-4 0,2.6e-4 0,2.6e-4 0,2.6e-4 m 0,-7.9e-4 c 0,-2.6e-4 0,-7.9e-4 2.65e-4,-10e-4 -2.65e-4,2.7e-4 -2.65e-4,8e-4 -2.65e-4,10e-4 m 2.65e-4,-10e-4 c 0,-8e-4 0,-0.002 2.64e-4,-0.002 -2.64e-4,7.9e-4 -2.64e-4,0.002 -2.64e-4,0.002 m 0.0013,-0.0102 v -2.7e-4 c 0,2.7e-4 0,2.7e-4 0,2.7e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1445",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31029 c 0,-2.6e-4 0,-2.6e-4 2.64e-4,-7.9e-4 -2.64e-4,2.6e-4 -2.64e-4,2.6e-4 -2.64e-4,7.9e-4 m 2.64e-4,-7.9e-4 c 0,-2.6e-4 0,-2.6e-4 0,-2.6e-4 0,0 0,0 0,2.6e-4 m 2.65e-4,-7.9e-4 c 0,0 0,0 0,-2.7e-4 0,2.7e-4 0,2.7e-4 0,2.7e-4 m 0,-8e-4 c 2.65e-4,0 2.65e-4,-2.6e-4 2.65e-4,-2.6e-4 0,0 0,2.6e-4 -2.65e-4,2.6e-4 m 2.65e-4,-2.6e-4 c 0,-2.7e-4 2.64e-4,-8e-4 2.64e-4,-0.001 0,2.6e-4 -2.64e-4,7.9e-4 -2.64e-4,0.001 m 7.93e-4,-0.002 c 2.65e-4,0 2.65e-4,-2.6e-4 2.65e-4,-2.6e-4 0,0 0,0 -2.65e-4,2.6e-4 m 0.0011,-0.002 c 0,-2.6e-4 0,-2.6e-4 2.64e-4,-7.9e-4 -2.64e-4,2.7e-4 -2.64e-4,2.7e-4 -2.64e-4,7.9e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1447",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0 c 0,0 0,0 0,-2.7e-4 v 0 0 -2.6e-4 0 -2.7e-4 c 0,0 0,0 0,-2.6e-4 0,0 0,-2.7e-4 0,-8e-4 2.64e-4,-2.6e-4 2.64e-4,-2.6e-4 2.64e-4,-2.6e-4 0,-2.7e-4 0,-2.7e-4 0,-8e-4 v 0 c 0,-2.6e-4 0,-2.6e-4 0,-7.9e-4 0,-2.6e-4 0,-7.9e-4 2.65e-4,-10e-4 0,-2.7e-4 0,-2.7e-4 0,-8e-4 0,0 0,0 0,-2.6e-4 0,0 0,0 0,-2.6e-4 0,-2.7e-4 0,-8e-4 2.65e-4,-10e-4 v -2.7e-4 c 0,-7.9e-4 0,-0.002 2.64e-4,-0.002 0,-0.002 2.65e-4,-0.005 0.0011,-0.008 0,0 0,0 0,-2.7e-4 0.08925,-0.66569 2.585154,-19.1269 4.573059,-22.57001 0.543629,-0.94121 1.264354,-1.71626 2.095852,-2.30752 0.424039,0.92781 0.6604,1.95897 0.6604,3.04553 0,4.0005 -7.155744,21.42243 -7.328607,21.84294 -2.64e-4,2.7e-4 -2.64e-4,2.7e-4 -2.64e-4,8e-4 -2.65e-4,7.9e-4 -7.94e-4,10e-4 -7.94e-4,0.002 0,0 0,2.6e-4 -2.65e-4,2.6e-4 0,2.7e-4 -2.64e-4,8e-4 -2.64e-4,0.001 0,2.7e-4 -2.65e-4,7.9e-4 -2.65e-4,10e-4 v 0 c 0,0 0,2.6e-4 -2.64e-4,2.6e-4 v 2.7e-4 c 0,2.6e-4 0,2.6e-4 0,2.6e-4 -2.65e-4,0 -2.65e-4,2.7e-4 -2.65e-4,2.7e-4 0,0 0,0 0,2.6e-4 v 0 c -2.65e-4,2.7e-4 -2.65e-4,2.7e-4 -2.65e-4,8e-4 v 2.6e-4 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1449",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c 0.02611,-0.0346 12.101338,-15.83832 15.610416,-22.78028 0.568677,0.0123 1.136299,0.0903 1.690159,0.23425 0.282223,0.49777 0.504473,1.02517 0.663575,1.57127 -5.751687,5.14562 -17.745779,20.69147 -17.961327,20.97087 0,2.7e-4 -2.65e-4,2.7e-4 -2.65e-4,8e-4 -0.0013,10e-4 -0.0021,0.002 -0.0024,0.003 v 0 c 0,2.6e-4 0,2.6e-4 0,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1451",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 c 0,0 0,0 0,-2.7e-4 0,2.7e-4 0,2.7e-4 0,2.7e-4 m 0,-2.7e-4 c 2.64e-4,-2.6e-4 0.0011,-0.001 0.0024,-0.003 -0.0013,10e-4 -0.0021,0.002 -0.0024,0.003 m 0.0028,-0.004 c 0.215548,-0.2794 12.20964,-15.82526 17.961327,-20.97087 0.258233,0.88582 0.349956,1.81927 0.261408,2.74955 -1.015294,0.0963 -2.027415,0.4071 -2.968625,0.95038 -3.47486,2.00625 -15.042444,16.99648 -15.25411,17.27094"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1453",
    style: {
      fill: "#254a61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 m 2.64e-4,-0.001 c 0,0 0,-2.7e-4 2.65e-4,-8e-4 -2.65e-4,2.7e-4 -2.65e-4,8e-4 -2.65e-4,8e-4 m 2.65e-4,-10e-4 c 0,-2.7e-4 2.65e-4,-8e-4 2.65e-4,-8e-4 0,0 -2.65e-4,2.7e-4 -2.65e-4,8e-4 m 7.94e-4,-0.002 c 2.64e-4,-2.7e-4 2.64e-4,-8e-4 2.64e-4,-10e-4 0,2.6e-4 0,7.9e-4 -2.64e-4,10e-4 m 7.93e-4,-10e-4 v -2.6e-4 2.6e-4 m 2.65e-4,-0.001 c 0,-2.7e-4 0,-2.7e-4 2.65e-4,-2.7e-4 -2.65e-4,0 -2.65e-4,0 -2.65e-4,2.7e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1455",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1457",
    style: {
      fill: "#193246",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0 0 c 0,-2.7e-4 0,-8e-4 2.64e-4,-0.001 0,0 0,-2.7e-4 2.65e-4,-8e-4 v -2.6e-4 c 0,-2.7e-4 2.65e-4,-8e-4 2.65e-4,-8e-4 0,-2.6e-4 2.64e-4,-7.9e-4 2.64e-4,-0.001 2.65e-4,-2.7e-4 2.65e-4,-8e-4 2.65e-4,-10e-4 2.64e-4,0 2.64e-4,-2.7e-4 2.64e-4,-2.7e-4 v -2.6e-4 c 2.65e-4,-2.7e-4 2.65e-4,-7.9e-4 2.65e-4,-7.9e-4 0,-2.7e-4 0,-2.7e-4 2.64e-4,-2.7e-4 0.16369,-0.39264 7.432324,-17.79729 10.263011,-20.62797 1.431925,-1.43158 3.308704,-2.14736 5.185127,-2.14736 0.05292,0 0.106539,7.1e-4 0.159456,0.002 -3.509079,6.94196 -15.58431,22.7457 -15.610417,22.78027 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1459",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 c 0,0 0,-2.7e-4 2.64e-4,-2.7e-4 -2.64e-4,0 -2.64e-4,0 -2.64e-4,2.7e-4 v 0 0 m 2.64e-4,-2.7e-4 2.65e-4,-2.6e-4 -2.65e-4,2.6e-4 m 7.94e-4,-7.9e-4 c 2.65e-4,0 7.94e-4,-2.7e-4 7.94e-4,-2.7e-4 0,0 -2.65e-4,2.7e-4 -7.94e-4,2.7e-4 m 0.0011,-8e-4 c 2.65e-4,-2.6e-4 7.94e-4,-7.9e-4 0.0011,-10e-4 -2.65e-4,2.7e-4 -7.94e-4,8e-4 -0.0011,10e-4 m 0.0019,-10e-4 c 2.64e-4,-2.6e-4 7.93e-4,-7.9e-4 0.0013,-0.001 -7.93e-4,2.7e-4 -0.0011,8e-4 -0.0013,0.001 m 0.0019,-0.001 c 7.93e-4,-2.7e-4 0.0013,-10e-4 0.0021,-10e-4 -7.93e-4,2.7e-4 -0.0013,10e-4 -0.0021,10e-4 m 0.0028,-0.002 c 0,0 2.64e-4,-2.6e-4 7.93e-4,-2.6e-4 -2.64e-4,0 -7.93e-4,2.6e-4 -7.93e-4,2.6e-4 m 0.0013,-0.001 2.64e-4,-2.6e-4 -2.64e-4,2.6e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1461",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 0 0 0 m 0,0 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1463",
    style: {
      fill: "#1e3c50",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31029 v 0 0 m 0.0024,-0.003 c 0,-2.6e-4 2.65e-4,-2.6e-4 2.65e-4,-7.9e-4 0,2.6e-4 -2.65e-4,2.6e-4 -2.65e-4,7.9e-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1465",
    style: {
      fill: "#16293a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.823301,257.31065 v 0 c 0,0 0,0 0,-2.7e-4 v 0 c 2.64e-4,-2.6e-4 0.0011,-0.001 0.0024,-0.003 0,-2.6e-4 2.65e-4,-2.6e-4 2.65e-4,-7.9e-4 0.211666,-0.27446 11.77925,-15.2647 15.25411,-17.27094 0.94121,-0.54328 1.953331,-0.85408 2.968625,-0.95039 -0.09631,1.0153 -0.407107,2.02706 -0.950735,2.96827 -1.993197,3.45299 -16.814448,14.90169 -17.264592,15.24882 l -2.65e-4,2.7e-4 c -2.64e-4,2.6e-4 -7.93e-4,2.6e-4 -7.93e-4,7.9e-4 -2.65e-4,0 -7.94e-4,2.7e-4 -7.94e-4,2.7e-4 -2.65e-4,2.6e-4 -7.94e-4,2.6e-4 -7.94e-4,7.9e-4 -7.94e-4,2.6e-4 -0.0013,0.001 -0.0021,0.001 0,2.7e-4 -2.64e-4,2.7e-4 -2.64e-4,2.7e-4 -7.94e-4,2.6e-4 -0.0011,7.9e-4 -0.0013,10e-4 -2.65e-4,2.6e-4 -2.65e-4,2.6e-4 -7.94e-4,2.6e-4 -2.64e-4,2.6e-4 -7.94e-4,7.9e-4 -0.0011,10e-4 -2.65e-4,0 -2.65e-4,0 -2.65e-4,2.6e-4 0,0 -2.64e-4,2.7e-4 -7.93e-4,2.7e-4 l -2.65e-4,2.6e-4 -2.65e-4,2.7e-4 v 0 c -2.64e-4,0 -2.64e-4,2.6e-4 -2.64e-4,2.6e-4 v 0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower13);
export default __webpack_public_path__ + "static/media/flower-13.2f82754aa08bc5a4eb5ea0a0873f2cd0.svg";
export { ForwardRef as ReactComponent };